import * as i0 from '@angular/core';
import { Directive, EventEmitter, Input, Output, NgModule, Injectable, Host, Self, Optional, Pipe, InjectionToken, Inject, LOCALE_ID, inject, SkipSelf, Component, input, ChangeDetectionStrategy, ViewContainerRef, signal, DEFAULT_CURRENCY_CODE, Injector, EnvironmentInjector, ApplicationRef, createComponent, ViewChild } from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbCollapseModule, NgbDatepickerI18nDefault, NgbDatepickerI18n, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, fromEvent, map, of, Subject, catchError, throwError, BehaviorSubject, from, EMPTY, timer, race } from 'rxjs';
import { throttleTime, tap, take, retryWhen, delay, timeout, map as map$1, finalize, concatMap, takeWhile, filter, mergeMap, catchError as catchError$1 } from 'rxjs/operators';
import * as i2 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i4 from '@angular/common';
import { CommonModule, NgClass, CurrencyPipe, DatePipe, DOCUMENT } from '@angular/common';
import * as i3 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, Store, StoreModule, ActionsSubject } from '@ngrx/store';
import * as i1$4 from '@design-factory/design-factory';
import { DfAlertModule, DfTooltipModule, DfProgressIndicatorModule, DfToastModule } from '@design-factory/design-factory';
import * as i1$1 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpClient, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as i1$2 from 'bear-1axml';
import { Bear1AXMLService } from 'bear-1axml';
import * as i1$3 from '@reef-rfd/model';
import { LanguageCode } from '@reef-rfd/model';
import * as i1$5 from '@angular/forms';
import { UntypedFormControl, FormsModule, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import * as i2$1 from '@angular/platform-browser';

class AutofocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.elementRef.nativeElement.focus();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AutofocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: AutofocusDirective, isStandalone: true, selector: "[amaAutoFocus]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AutofocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amaAutoFocus]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });

/* eslint-disable @angular-eslint/directive-selector */
class NgbDOBDatepickerDirective {
    constructor(ngbInputDatepicker) {
        this.ngbInputDatepicker = ngbInputDatepicker;
    }
    ngOnInit() {
        this.addDOBConfiguration(this.ngbInputDatepicker, this.generateDOBConfiguration());
    }
    /**
     * Generate the datepicker configuration for date of birth.
     */
    generateDOBConfiguration() {
        const today = new Date();
        return {
            minDate: { year: 1900, month: 1, day: 1 },
            maxDate: { year: today.getUTCFullYear(), month: today.getUTCMonth() + 1, day: today.getUTCDate() }
        };
    }
    /**
     * Add Date of birth configuration to the generic datepicker.
     * @param datepicker NgBootstrap datepicker (generated by component or directive)
     * @param config Configuration for date of birth
     */
    addDOBConfiguration(datepicker, config) {
        const confKeys = Object.keys(config);
        confKeys.forEach((key) => {
            datepicker[key] = config[key];
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NgbDOBDatepickerDirective, deps: [{ token: i1.NgbInputDatepicker }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: NgbDOBDatepickerDirective, isStandalone: true, selector: "input[ngbDatepicker]input[amaNgbDOBDatepicker]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NgbDOBDatepickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[ngbDatepicker]input[amaNgbDOBDatepicker]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i1.NgbInputDatepicker }] });

class ScrollSpyDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.spySelector = '.ama-scroll-spy-selector';
        this.nodeChange = new EventEmitter();
        this.currentNode = document;
        this.eventSub = new Subscription();
    }
    ngAfterViewInit() {
        this.eventSub.add(fromEvent(this.elementRef.nativeElement, 'scroll')
            .pipe(throttleTime(100), tap((e) => this.onScroll(e)))
            .subscribe());
    }
    ngOnDestroy() {
        this.eventSub.unsubscribe();
    }
    onScroll(event) {
        let currentNode = document;
        const scrollTop = event.target.scrollTop;
        const parentOffset = event.target.offsetTop;
        const children = this.elementRef.nativeElement.querySelectorAll(this.spySelector);
        if (children.length === 0) {
            return;
        }
        for (const element of children) {
            if (element.offsetTop - parentOffset <= scrollTop) {
                currentNode = element;
            }
        }
        if (currentNode !== this.currentNode) {
            this.currentNode = currentNode;
            this.nodeChange.emit(this.currentNode);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollSpyDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: ScrollSpyDirective, isStandalone: true, selector: "[amaScrollSpy]", inputs: { spySelector: "spySelector" }, outputs: { nodeChange: "nodeChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ScrollSpyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amaScrollSpy]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { spySelector: [{
                type: Input
            }], nodeChange: [{
                type: Output
            }] } });

class CoreDirectivesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CoreDirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: CoreDirectivesModule, imports: [NgbDOBDatepickerDirective, AutofocusDirective, ScrollSpyDirective], exports: [NgbDOBDatepickerDirective, AutofocusDirective, ScrollSpyDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CoreDirectivesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CoreDirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NgbDOBDatepickerDirective, AutofocusDirective, ScrollSpyDirective],
                    exports: [NgbDOBDatepickerDirective, AutofocusDirective, ScrollSpyDirective]
                }]
        }] });

class PrefixConfigService {
    constructor() {
        this.nextId = 0;
    }
    /**
     * Set the prefix configuration.
     * @param prefix a new prefix
     */
    setPrefixConfig(prefix) {
        this.prefix = prefix;
    }
    /**
     * Get the prefix configuration.
     */
    getPrefixConfig() {
        if (!this.prefix) {
            return '';
        }
        return this.prefix;
    }
    /**
     * Get a generated id number that is unique (for this injected service)
     */
    getNextId() {
        this.nextId++;
        return this.nextId.toString();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PrefixConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PrefixConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PrefixConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class IdGenerationDirective {
    /**
     * @param renderer
     * @param el Element reference of the host of the directive
     * @param prefixConfigService Token injected using PREFIX_CONFIG_TOKEN, used to prefix id and for
     * @param hostNgSelectComponent Used to dynamically add the id to the dynamically generated input of a NgSelect
     */
    constructor(renderer, el, prefixConfigService, hostNgSelectComponent) {
        this.renderer = renderer;
        this.el = el;
        this.prefixConfigService = prefixConfigService;
        this.hostNgSelectComponent = hostNgSelectComponent;
    }
    ngAfterContentInit() {
        const prefix = this.prefixConfigService.getPrefixConfig() ? this.prefixConfigService.getPrefixConfig() : '';
        if (this.prefixId) {
            this.renderer.setAttribute(this.el.nativeElement, 'id', prefix + this.prefixId);
        }
        else if (this.prefixFor) {
            this.renderer.setAttribute(this.el.nativeElement, 'for', prefix + this.prefixFor);
        }
        else if (this.prefixAriaControls) {
            this.renderer.setAttribute(this.el.nativeElement, 'aria-controls', prefix + this.prefixAriaControls);
        }
        else if (this.prefixLabelForId) {
            const prefixedId = prefix + this.prefixLabelForId;
            this.renderer.setAttribute(this.el.nativeElement, 'labelForId', prefixedId);
            if (this.hostNgSelectComponent) {
                this.hostNgSelectComponent.labelForId = prefixedId;
            }
        }
        else if (this.prefixAriaLabelledby) {
            this.renderer.setAttribute(this.el.nativeElement, 'aria-labelledby', prefix + this.prefixAriaLabelledby);
        }
        else {
            throw new Error(this.el.nativeElement.outerHTML + '\nid to generate not define');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: PrefixConfigService }, { token: i2.NgSelectComponent, host: true, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: IdGenerationDirective, isStandalone: true, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: { prefixId: "prefixId", prefixFor: "prefixFor", prefixAriaControls: "prefixAriaControls", prefixLabelForId: "prefixLabelForId", prefixAriaLabelledby: "prefixAriaLabelledby" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: PrefixConfigService }, { type: i2.NgSelectComponent, decorators: [{
                    type: Host
                }, {
                    type: Self
                }, {
                    type: Optional
                }] }], propDecorators: { prefixId: [{
                type: Input
            }], prefixFor: [{
                type: Input
            }], prefixAriaControls: [{
                type: Input
            }], prefixLabelForId: [{
                type: Input
            }], prefixAriaLabelledby: [{
                type: Input
            }] } });

class IdGenerationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationModule, imports: [IdGenerationDirective], exports: [IdGenerationDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: IdGenerationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdGenerationDirective],
                    exports: [IdGenerationDirective]
                }]
        }] });

/**
 * These are flags for the screen size of the device
 */
var DeviceSize;
(function (DeviceSize) {
    DeviceSize[DeviceSize["ExtraSmall"] = 1] = "ExtraSmall";
    DeviceSize[DeviceSize["Small"] = 2] = "Small";
    DeviceSize[DeviceSize["Medium"] = 4] = "Medium";
    DeviceSize[DeviceSize["Large"] = 8] = "Large";
    DeviceSize[DeviceSize["ExtraLarge"] = 16] = "ExtraLarge";
    DeviceSize[DeviceSize["ExtraExtraLarge"] = 32] = "ExtraExtraLarge";
})(DeviceSize || (DeviceSize = {}));

/* eslint-disable no-bitwise */
class MediaService {
    constructor() {
        /**
         * These rules are mapped to the DF screen breakpoint rules defined here:
         * {@link https://rndwww.nce.amadeus.net/confluence/display/UFSCD/Grid+and+breakpoints}
         */
        this.rules = {
            extraSmall: { min: 0, max: 575.99 },
            small: { min: 576, max: 767.99 },
            medium: { min: 768, max: 991.99 },
            large: { min: 992, max: 1199.99 },
            extraLarge: { min: 1200, max: 1439.99 },
            extraExtraLarge: { min: 1440, max: 99999 }
        };
        this.mapToRules = new Map();
        this.mapToRules.set(DeviceSize.ExtraSmall, this.rules.extraSmall);
        this.mapToRules.set(DeviceSize.Small, this.rules.small);
        this.mapToRules.set(DeviceSize.Medium, this.rules.medium);
        this.mapToRules.set(DeviceSize.Large, this.rules.large);
        this.mapToRules.set(DeviceSize.ExtraLarge, this.rules.extraLarge);
        this.mapToRules.set(DeviceSize.ExtraExtraLarge, this.rules.extraExtraLarge);
    }
    /**
     * The entry point of the service. You need to add your breakpoints and your needed behaviour
     * when you enter or leave the needed device size.
     * {number} devices bit mask of {@link DeviceSize}
     * {Function} callbackOnMatch is a closure we call when we match the wanted deviceSize
     * {Function} callbackOnMismatch is a closure we call when we do not match the wanted device size
     */
    addCallbackTo(devices, callbackOnMatch, callbackOnMismatch) {
        const mediaQuery = window.matchMedia(this.constructMediaQuery(devices));
        const checkMediaQuery = (mql) => {
            if (mql.matches) {
                callbackOnMatch();
            }
            else {
                callbackOnMismatch();
            }
        };
        mediaQuery.addListener((mql) => {
            checkMediaQuery(mql);
        });
        checkMediaQuery(mediaQuery);
    }
    /**
     * This construct the media query to match according to the devices needed
     * {number} devices bit mask of {@link DeviceSize}
     * {string}
     */
    constructMediaQuery(devices) {
        return [...this.mapToRules.keys()]
            .filter((deviceSize) => devices & deviceSize)
            .map((deviceSize) => {
            const boundaries = this.getBoundaries(deviceSize);
            return `(min-width: ${boundaries.min}px) and (max-width: ${boundaries.max}px)`;
        })
            .join(',');
    }
    getBoundaries(deviceSize) {
        const boundaries = this.mapToRules.get(deviceSize);
        if (!boundaries) {
            throw new Error(`Boundaries are not defined: ${DeviceSize[deviceSize]}`);
        }
        return boundaries;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MediaService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MediaService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MediaService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class ShouldDisplayOnDeviceDirective {
    constructor(templateRef, viewContainer, mediaService, zone) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.mediaService = mediaService;
        this.zone = zone;
        this.hasView = false;
    }
    /**
     * Uses the {@link MediaService} in order to refresh the view when the screen size matches the deviceSize bitmask
     * {number} devices bitmask of the devices on which we need to display the current content
     */
    set amaShouldDisplayOn(devices) {
        const callbackOnMatch = () => {
            if (!this.hasView) {
                this.zone.run(() => {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                });
            }
        };
        const callbackOnMisMatch = () => {
            if (this.hasView) {
                this.zone.run(() => {
                    this.viewContainer.clear();
                    this.hasView = false;
                });
            }
        };
        this.mediaService.addCallbackTo(devices, callbackOnMatch.bind(this), callbackOnMisMatch.bind(this));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ShouldDisplayOnDeviceDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: MediaService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: ShouldDisplayOnDeviceDirective, isStandalone: true, selector: "[amaShouldDisplayOn]", inputs: { amaShouldDisplayOn: "amaShouldDisplayOn" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ShouldDisplayOnDeviceDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amaShouldDisplayOn]',
                    standalone: true
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: MediaService }, { type: i0.NgZone }], propDecorators: { amaShouldDisplayOn: [{
                type: Input
            }] } });

class ResponsiveDirectivesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveDirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveDirectivesModule, imports: [CommonModule, ShouldDisplayOnDeviceDirective], exports: [ShouldDisplayOnDeviceDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveDirectivesModule, providers: [MediaService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResponsiveDirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ShouldDisplayOnDeviceDirective],
                    exports: [ShouldDisplayOnDeviceDirective],
                    providers: [MediaService]
                }]
        }] });

// Core directives module

/** @dynamic */
class ArrayHelper {
    /**
     * Takes an array of items and the name of a property of these items, and returns an array of the items grouped
     * by the given property.
     * Example 1 : groupBy(['one', 'two', 'three'], 'length') would return {3: ['one', 'two'], 5: ['three']}
     * Example 2 : groupBy(
     *   [{type:'Dog', name:'Spot'}, {type:'Cat', name:'Tiger'}, {type:'Dog', name:'Rover'}, {type:'Cat', name:'Leo'}],
     *   'type'
     *  ) would return {
     *     'Dog': [{type:'Dog', name:'Spot'}, {type:'Dog', name:'Rover'}],
     *     'Cat': [{type:'Cat', name:'Leo'}, {type:'Cat', name:'Tiger'}]
     *   }
     * @param items array of items
     * @param itemProperty name of the property for which we want the our items to be grouped
     */
    static groupBy(items, itemProperty) {
        return items.reduce((accumulator, currentValue) => {
            const current = currentValue[itemProperty];
            if (typeof current === 'string' || typeof current === 'number' || typeof current === 'symbol') {
                accumulator[current] = accumulator[current] || [];
                accumulator[current].push(currentValue);
                return accumulator;
            }
            throw new Error('Grouping should be done by number, string or symbol item property');
        }, {});
    }
    /**
     * Method used to compare if 2 arrays contain same items
     * Example 1 : containSameItems(['one', 'two', 'three'], ['two', 'one', 'three']) would return true
     * Example 2 : containSameItems(['one', 'two', 'three'], ['two', 'one']) would return false
     * @param array1
     * @param array2
     * @returns boolean
     */
    static containSameItems(array1, array2) {
        if (array1.length !== array2.length) {
            return false;
        }
        return array1.filter((item) => !array2.includes(item)).length === 0;
    }
    /**
     * Method used to check if 2nd array contain 1st array
     * Example 1 : containAllItems(['one', 'two'], ['two', 'one', 'three']) would return true
     * Example 2 : containAllItems(['one', 'two'], ['one', 'three']) would return false
     * @param array1
     * @param array2
     * @returns boolean
     */
    static containAllItems(array1, array2) {
        if (!array1 || !array2 || array1.length > array2.length) {
            return false;
        }
        return array1.every((item) => array2.indexOf(item) > -1);
    }
    /**
     * Returns a new list containing common elements in the input arrays
     * @param arrays a list of arrays
     * @returns a new list with the elements in common among all the lists
     */
    static intersect(arrays) {
        if (!arrays.length) {
            return [];
        }
        return arrays.reduce((acc, arr) => {
            const uniq = new Set(arr);
            return acc.filter((x) => uniq.has(x));
        }, [...new Set(arrays[0])]);
    }
}

const dayLengthInMs = 1000 * 60 * 60 * 24;
class DateHelper {
    static { this.MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']; }
    /**
     * Returns a number corresponding to the number of day difference between date1 and date2
     * Ex: if date1 = Wed Feb 27 2019 11:04:16 GMT+0100 and date2 = Tue Feb 26 2019 15:08:16 GMT+0100, it would return 1
     * @param date1
     * @param date2
     */
    static getDayDiff(date1, date2) {
        const date1TimestampMs = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()); // timestamp in milliseconds
        const date2TimestampMs = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()); // timestamp in milliseconds
        return (date1TimestampMs - date2TimestampMs) / dayLengthInMs;
    }
    /**
     * Calculates the day difference between date1 and date2. If dayDiff = 0, it returns an empty string.
     * If DayDiff >=1, it returns '+${dayDiff}' else if dayDiff is negative it returns '-${dayDiff}'
     * @param date1
     * @param date2
     */
    static getDayDiffToString(date1, date2) {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        if (!isNaN(d1.getTime()) && !isNaN(d2.getTime())) {
            const dayDiff = DateHelper.getDayDiff(d1, d2);
            if (dayDiff === 0) {
                return '';
            }
            if (dayDiff > 0) {
                return '+' + dayDiff;
            }
            return dayDiff.toString(); // if it's negative we just return using 'toString' method, which will add the '-' in front
        }
        return null;
    }
    /**
     * Return diff between 2 days
     * @param dateString1 date in format yyyy-MM-dd
     * @param dateString2 date in format yyyy-MM-dd
     */
    static getDayDiffFromString(dateString1, dateString2) {
        const date1 = new Date(dateString1).valueOf();
        const date2 = new Date(dateString2).valueOf();
        if (!Number.isNaN(date1) && !Number.isNaN(date2)) {
            return Math.abs((date2 - date1) / dayLengthInMs);
        }
        else {
            return null;
        }
    }
    /**
     * Strip GMT and UTC appendix so that timezone issues are prevented for dates.
     *
     * As date formats may differ depending on serialization, consider both old and new format
     * 2020/04/01 00:00:00 GMT+0000 or 2020/04/01 00:00:00 GMT
     * @param dateString
     * @return modified string without timezone appendix
     */
    static stripTimezone(dateString) {
        // eslint-disable-next-line @typescript-eslint/no-inferrable-types
        const regex = / GMT(\+0000)?| UTC(\+0000)?/;
        return dateString.replace(regex, '');
    }
    /**
     * Normalize a date string into the ISO date format without timezone
     * @param dateString a date string from one of the following formats:
     *        - 2021-07-14
     *        - 2021/07/14
     *        - 2021/07/14 10:55:24
     *        - 2021-07-14 10:55:24
     *        - 2021-07-14T10:55:24
     * @returns a date string in the ISO date format without timezone
     */
    static normalizeDateStr(dateString) {
        if (!dateString || dateString.length === 0) {
            return dateString;
        }
        const d = this.stripTimezone(dateString);
        // 2021-07-14
        const m1 = d?.match(/^\d\d\d\d-\d\d-\d\d$/);
        if (m1) {
            return `${d}`;
        }
        // 2021/07/14
        const m2 = d?.match(/^(\d\d\d\d)\/(\d\d)\/(\d\d)$/);
        if (m2) {
            return `${m2[1]}-${m2[2]}-${m2[3]}`;
        }
        // 2021/07/14 10:55:24
        const m3 = d?.match(/^(\d\d\d\d)\/(\d\d)\/(\d\d) (\d\d):(\d\d):(\d\d)$/);
        if (m3) {
            return `${m3[1]}-${m3[2]}-${m3[3]}T${m3[4]}:${m3[5]}:${m3[6]}`;
        }
        // 2021-07-14 10:55:24
        const m4 = d?.match(/^(\d\d\d\d)-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/);
        if (m4) {
            return `${m4[1]}-${m4[2]}-${m4[3]}T${m4[4]}:${m4[5]}:${m4[6]}`;
        }
        // 2021-07-14T10:55:24
        const m5 = d?.match(/^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)$/);
        if (m5) {
            return `${d}`;
        }
        return d;
    }
    /**
     * Checks if the provided object has day,month and year properties and can be assigned to a NgbDateStruct object
     *
     * @param date any javascript object
     * @returns true if the provided object can be assigned to a NgbDateStruct object
     */
    static isNgbDateStruct(date) {
        return !!date && date.hasOwnProperty('day') && date.hasOwnProperty('month') && date.hasOwnProperty('year');
    }
    /**
     *
     * @param date NgbDateStruct element to convert
     * @param useYY? default false - if true date year converted to 2 digits from 4 digits
     * @returns formats NgbDateStruct date as DDMMYYYY string
     */
    static getNgbDateAsDDMMYYYY(date, useYY = false) {
        if (!date) {
            return '';
        }
        else {
            const day = `0${date.day}`.slice(-2);
            const month = `0${date.month}`.slice(-2);
            const year = useYY ? date.year.toString().slice(-2) : date.year.toString();
            return `${day}${month}${year}`;
        }
    }
    /**
     * @param dateStr date string that will be parsed using new {Date(dateStr)}
     * @returns NgbDateStruct for DF calendar
     */
    static toNgbDate(dateStr) {
        if (!dateStr || dateStr.trim().length === 0) {
            return null;
        }
        return DateHelper.dateToNgbDate(new Date(dateStr));
    }
    /**
     *
     * @param date Date that will be used to match NgbDateStruct
     * @returns NgbDateStrut for DF calendar
     */
    static dateToNgbDate(date) {
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
    /**
     * @param date a date string in format DDMMYY, ie 010620 --> 1st june 2020
     * @returns a date string in format DDMMMYY, ie 01JUN20
     */
    static getDDMMYYasDDMMMYY(date) {
        if (!date) {
            return date;
        }
        const numMonth = Number.parseInt(date.substring(2, 4), 10);
        const month = this.MONTHS[numMonth - 1];
        return `${date.substring(0, 2)}${month}${date.substring(4)}`;
    }
    /**
     * @param date a date string in format DDMMMYY, ie 15DEC22
     * @returns a date string in format YYYY-MM-DD, ie 2022-12-15
     */
    static getDDMMMYYasIso(date) {
        if (!date || !date.match(/\d{2}[A-Z]{3}\d{2}/)) {
            return date;
        }
        const month = date.substring(2, 5);
        const numMonth = this.MONTHS.indexOf(month) + 1;
        const monthStr = `0${numMonth}`.slice(-2);
        return `20${date.substring(5)}-${monthStr}-${date.substring(0, 2)}`;
    }
    /**
     * @param date a date string in format MMYY, ie 0620 --> june 2020
     * @returns a date string in format MMMYYYY, ie JUN2020
     */
    static getMMYYAsMMMYYYY(date) {
        if (!date) {
            return date;
        }
        const numMonth = Number.parseInt(date.substring(0, 2), 10);
        const month = this.MONTHS[numMonth - 1];
        return `${month}20${date.substring(2)}`;
    }
    /**
     * @param time a "human" date string in time format:
     *        - 2:30 (0230)
     *        - 02:30 (0230)
     *        - 2PM (0200)
     *        - 02:30 PM (1430)
     *        - 12:45 PM (1245)
     *        - 12:45 AM (0045)
     *        - 02 a.m. (0200)
     *        - 2:2 (0202)
     * @returns a time string in format hhmm, ie 1230
     */
    static convertToHHmm(time) {
        // regexp detect a time in this format hh:mm AM
        // hour is mandatory with 1 or 2 digits
        // separator between hour and minutes is optional and can be : or h
        // minute is optional, 0, 1 or 2 digits
        // space is autorized after time
        // Optional merdiem detection (AM/PM) with optional separator . (a.m.)
        const regexp = /^([0-9]{1,2})[:|h]{0,1}([0-9]{0,2})[\s]*([A,P]{0,1})[.]{0,1}([M]{0,1})[.]{0,1}$/i;
        const result = regexp.exec(time);
        if (result) {
            const meridiem = result[3].concat(result[4]).toUpperCase();
            let hour = parseInt(result[1], 10);
            // 12AM and 12PM cases
            if (hour === 12 && (meridiem === 'AM' || meridiem === 'PM')) {
                hour -= 12;
            }
            const hh = (meridiem === 'PM' ? hour + 12 : hour).toString().padStart(2, '0');
            const mm = result[2].padStart(2, '0');
            const hhRange = (meridiem !== 'AM' && parseInt(hh, 10) <= 23) || (meridiem === 'AM' && parseInt(hh, 10) <= 11);
            const mmRange = parseInt(mm, 10) <= 59;
            const meridienCompliant = ['', 'AM', 'PM'].indexOf(meridiem) > -1;
            if (hhRange && mmRange && meridienCompliant) {
                return hh.concat(mm);
            }
        }
        return time;
    }
}

var KeyBinding;
(function (KeyBinding) {
    KeyBinding[KeyBinding["ENTER"] = 13] = "ENTER";
    KeyBinding[KeyBinding["ARROW_LEFT"] = 37] = "ARROW_LEFT";
    KeyBinding[KeyBinding["ARROW_UP"] = 38] = "ARROW_UP";
    KeyBinding[KeyBinding["ARROW_RIGHT"] = 39] = "ARROW_RIGHT";
    KeyBinding[KeyBinding["ARROW_DOWN"] = 40] = "ARROW_DOWN";
})(KeyBinding || (KeyBinding = {}));

class PropertyHelper {
    /**
     *  Returns a property if it exists in a given object
     *  @param object {any} Parent object
     *  @param propertyPath {string} Property path
     */
    static getProperty(object, propertyPath) {
        if (!object || !propertyPath || !propertyPath.length) {
            return undefined;
        }
        const result = propertyPath.split('.').reduce((current, next) => {
            const match = next.match('\\[(.*?)\\]');
            if (current) {
                // if the next property is an array, we parse the index
                return match && Array.isArray(current[next.substring(0, match.index)])
                    ? current[next.substring(0, match.index)][parseInt(match[1], 10)]
                    : current[next];
            }
            else {
                return current;
            }
        }, object);
        return result ? result : undefined;
    }
}

/**
 * Character Map for diacritics vs base character
 * Map created for faster access
 * see https://github.com/ng-select/ng-select/blob/master/src/ng-select/lib/search-helper.ts
 */
const DEFAULT_DIACRITIC_CHAR_MAP = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
};
/** @dynamic */
class StringHelper {
    /**
     * This function returns a string without the accents
     * For example, stripAccents('ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž')
     * would return 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'
     * If there is a mapping existing for the character in the map, then replace with the corresponding 'base' character
     * see DEFAULT_DIACRITIC_CHAR_MAP for the cleaned diacritics
     * For range of ASCII code refer see https://en.wikipedia.org/wiki/Latin_script_in_Unicode
     *
     * Solution referred from see https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
     * and see https://github.com/ng-select/ng-select/blob/master/src/ng-select/lib/search-helper.ts
     */
    static stripAccents(str) {
        // eslint-disable-next-line
        return str.replace(/[^\u0000-\u007E]/g, character => DEFAULT_DIACRITIC_CHAR_MAP[character] || character);
    }
    /**
     * Escapes special characters in a string to be used in a regular expression.
     *
     * This method takes a string and replaces characters that have special meaning
     * in regular expressions (such as ., *, +, ?, ^, $, {, }, (, ), |, [, ], \) with
     * their escaped counterparts.
     *
     * @param str - The input string containing characters to be escaped.
     * @returns The escaped string, safe to use in a regular expression.
     */
    static escapeRegexSpecialChars(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    // this function return the starting indexes of a substring in a string
    // example indexesOf('aaparbb paris', 'par') would return [2,8]
    static indexesOf(str, substr) {
        return str
            .split(substr)
            .slice(0, -1)
            .map(s => s.length)
            .map((_, i, lengths) => lengths.slice(0, i + 1).reduce((a, b) => a + b, i * substr.length));
    }
    /**
     * This function formats string to title case
     * example: formatTitleCase('TOM LEE') would return 'Tom Lee'
     */
    static formatTitleCase(value) {
        return value.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }
    /**
     * @param left string to compare
     * @param right string to compare
     * @returns true if both strings are undefined or null
     *          true if both strings are defined and have same value
     *          false otherwise
     */
    static compareStr(left, right) {
        if (!left && !right) {
            return true;
        }
        return left === right;
    }
    /**
     * This function splits string into groups of {n} consecutive characters.
     * If string length is not a multiple of {n}, the last group will be shorter than {n}
     * @param value source string
     * @param n desired size of a group
     * @returns an array of substrings of {n} length
     */
    static splitInGroups(value, n) {
        return Array.from(value.match(new RegExp(`.{1,${n}}`, 'g')) ?? []);
    }
}

function assertNotNull(value) {
    if (value === null || value === undefined) {
        throw new Error('Unexpected null or undefined value');
    }
}
function assertNotNull$(observable) {
    return observable.pipe(map((value) => {
        assertNotNull(value);
        return value;
    }));
}

var MessageType;
(function (MessageType) {
    MessageType["SUCCESS"] = "O";
    MessageType["INFO"] = "I";
    MessageType["WARNING"] = "W";
    MessageType["ERROR"] = "E";
    MessageType["CRITICAL"] = "C";
    MessageType["FATAL"] = "F";
})(MessageType || (MessageType = {}));
var BootstrapAlertType;
(function (BootstrapAlertType) {
    BootstrapAlertType["SUCCESS"] = "success";
    BootstrapAlertType["INFO"] = "info";
    BootstrapAlertType["WARNING"] = "warning";
    BootstrapAlertType["DANGER"] = "danger";
})(BootstrapAlertType || (BootstrapAlertType = {}));
class GroupedMessages {
    constructor() {
        this.success = [];
        this.info = [];
        this.warning = [];
        this.danger = [];
    }
}
class AdditionalMessageInfo {
}

var PnrOptions;
(function (PnrOptions) {
    PnrOptions["END_TRANSACT"] = "ET";
    PnrOptions["END_TRANSACT_RETRIEVE"] = "ER";
    PnrOptions["END_TRANSACT_CHANGE_ADVICE"] = "ETK";
    PnrOptions["END_TRANSACT_RETRIEVE_CHANGE_ADVICE"] = "ERK";
    PnrOptions["END_TRANSACT_SPLIT_PNR"] = "EF";
    PnrOptions["IGNORE"] = "IG";
    PnrOptions["IGNORE_RETRIEVE"] = "IR";
})(PnrOptions || (PnrOptions = {}));
// Error code when we try to re retrieve but we don't have pnr in session
const PNRRET_ERROR_PNR_SESSION = '15';
const PnrRetErrorMapping = {
    INF: MessageType.INFO,
    PL: MessageType.INFO,
    WEC: MessageType.WARNING,
    WA: MessageType.WARNING,
    EC: MessageType.ERROR
};

const PROFILE_REQUEST_VERSION = 12.7;
const UNIQUE_ID_TYPE = {
    RECLOC: { id: '21', context: 'CSX' },
    CUST_REFERENCE: { id: '21', context: 'PIN' },
    FF_CODE: { id: '21', context: 'LOYALTYNUMBER' },
    OFFICE_ID: { id: '9', context: 'CSX' },
    AIRCODE: { id: '9', context: 'AIRCODE' },
    OFFICE_ID_NGP: { id: '9', context: 'NGP_HomeID' },
    COMPANY_ID: { id: '9', context: 'NGP' }
};
var PROFILE_TYPE_CODE;
(function (PROFILE_TYPE_CODE) {
    PROFILE_TYPE_CODE["Traveller"] = "1";
    PROFILE_TYPE_CODE["Company"] = "3";
    PROFILE_TYPE_CODE["Group"] = "6";
    PROFILE_TYPE_CODE["Agency"] = "25";
    PROFILE_TYPE_CODE["Corporate"] = "20";
    PROFILE_TYPE_CODE["Frequent_flyer"] = "21";
})(PROFILE_TYPE_CODE || (PROFILE_TYPE_CODE = {}));
var PROFILE_STATUS;
(function (PROFILE_STATUS) {
    PROFILE_STATUS["ACTIVE"] = "A";
    PROFILE_STATUS["DELETED"] = "D";
})(PROFILE_STATUS || (PROFILE_STATUS = {}));
const MAXRESPONSE = 50;

var QmCommands;
(function (QmCommands) {
    QmCommands["ERCOPY"] = "ERCOPY";
    QmCommands["QE"] = "QE";
    QmCommands["ER"] = "ER";
    QmCommands["TTP"] = "TTP";
    QmCommands["TTM"] = "TTM";
    QmCommands["TRFP"] = "TRFP";
    QmCommands["TRDC"] = "TRDC";
})(QmCommands || (QmCommands = {}));
var QmTriggerOrigins;
(function (QmTriggerOrigins) {
    QmTriggerOrigins["BOOK"] = "Book";
    QmTriggerOrigins["PLACE_ON_QUEUE"] = "Place on Queue";
    QmTriggerOrigins["SEND_RESERVATION_REQUEST"] = "Send Reservation Request";
    QmTriggerOrigins["REISSUE"] = "Reissue";
    QmTriggerOrigins["ISSUE_AND_PAY"] = "Issue and pay";
    QmTriggerOrigins["BOOK_AND_PAY"] = "Book and pay";
    QmTriggerOrigins["BOOK_SEATS"] = "Book Seats";
    QmTriggerOrigins["REQUEST"] = "Request";
    QmTriggerOrigins["ISSUE"] = "Issue";
    QmTriggerOrigins["REFUND"] = "Refund now";
    QmTriggerOrigins["CANCEL"] = "Void now";
    QmTriggerOrigins["COPY_PNR"] = "Copy PNR";
})(QmTriggerOrigins || (QmTriggerOrigins = {}));

const CONFIG_TOKEN = 'component.config';
/**
 * Service to insure the unicity of the config token for some services which use the module injector provider instead of the component.
 */
class ConfigTokenService {
    /**
     * Set the config token.
     * @param config a new config token
     */
    setConfigToken(config) {
        this.config = config;
    }
    /**
     * Get the config token.
     */
    getConfigToken() {
        if (!this.config) {
            return {};
        }
        return this.config;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfigTokenService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfigTokenService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfigTokenService, decorators: [{
            type: Injectable
        }] });

/**
 * Pipe to get a default text if the associated value is empty.
 * @param value Value to be replaced if empty.
 * @param placeholder Placeholder to use, '-' by default.
 */
class DefaultTextPipe {
    constructor() {
        this.DEFAULT_TEXT = '-';
    }
    transform(value, defaultText = this.DEFAULT_TEXT) {
        return value && value.length ? value : defaultText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: DefaultTextPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: DefaultTextPipe, isStandalone: true, name: "defaultText" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: DefaultTextPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'defaultText', standalone: true }]
        }] });

/**
 * Pipe to iterate over object keys with *ngFor
 * to be used like this in templates:
 * ```
 *  *ngFor="let key of globalLists | keys"
 * ```
 * globalLists is an object.
 */
class KeysPipe {
    transform(value) {
        return value ? Object.keys(value) : [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: KeysPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: KeysPipe, isStandalone: true, name: "keys" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: KeysPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'keys', standalone: true }]
        }] });

/**
 * Pipe to convert upper case name to a lower case
 * with first letter in upper case.
 * E.g. from TOMMY LEE to Tommy Lee
 */
class NameFormatterPipe {
    transform(value) {
        return value
            ?.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NameFormatterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: NameFormatterPipe, isStandalone: true, name: "nameFormatter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NameFormatterPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'nameFormatter', standalone: true }]
        }] });

/**
 * Pipe to remove attributes from HTML
 * E.g. from <a href="not-amadeus-url">Tommy Lee</a> to Tommy Lee
 * Requested for US SECO-43025
 */
class RemoveHtmlAttributesPipe {
    static removeHtmlAttributes(value) {
        return value.split(new RegExp('<[^>]*>')).join('');
    }
    /**
     *
     * @param value
     * @param removeAttributes when used in loop and we have a condition when to remove attributes
     */
    transform(value, removeAttributes = true) {
        if (removeAttributes && value) {
            return RemoveHtmlAttributesPipe.removeHtmlAttributes(value);
        }
        else {
            return value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RemoveHtmlAttributesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: RemoveHtmlAttributesPipe, isStandalone: true, name: "removeHtmlAttributes" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RemoveHtmlAttributesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'removeHtmlAttributes',
                    standalone: true
                }]
        }] });

/**
 * Pipe to convert upper case string to a lower case
 * with first letter of the sentence in upper case.
 * E.g. from TOMMY LEE to Tommy lee
 */
class SentenceCasePipe {
    transform(value) {
        if (!value) {
            return value;
        }
        return value[0].toUpperCase() + value.substr(1).toLowerCase();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SentenceCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: SentenceCasePipe, isStandalone: true, name: "sentenceCase" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SentenceCasePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'sentenceCase', standalone: true }]
        }] });

class CorePipesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CorePipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: CorePipesModule, imports: [KeysPipe, NameFormatterPipe, SentenceCasePipe, RemoveHtmlAttributesPipe, DefaultTextPipe], exports: [KeysPipe, NameFormatterPipe, SentenceCasePipe, RemoveHtmlAttributesPipe, DefaultTextPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CorePipesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CorePipesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [KeysPipe, NameFormatterPipe, SentenceCasePipe, RemoveHtmlAttributesPipe, DefaultTextPipe],
                    exports: [KeysPipe, NameFormatterPipe, SentenceCasePipe, RemoveHtmlAttributesPipe, DefaultTextPipe]
                }]
        }] });

const NAVIGATE = '[AlertManagerNavigation] Navigate on click of alert';
class Navigate {
    constructor(target) {
        this.target = target;
        this.type = NAVIGATE;
    }
}

const OPEN_NEW_CMD_PAGE = '[Navigation] Open new command page';
class OpenNewCmdPage {
    constructor() {
        this.type = OPEN_NEW_CMD_PAGE;
    }
}

const PROFILE_UPDATE_TOP_BAR = '[Profile] Update top bar with newly created profile details';
const PROFILE_TRANSFER_PRF_BF = '[Profile] Do a blind transfer from Profile to Booking File';
const PROFILE_OPEN_ASSOC = '[Profile] Open an assosciated Profile';
class ProfileTransferPrfBF {
    constructor(transferParams) {
        this.transferParams = transferParams;
        this.type = PROFILE_TRANSFER_PRF_BF;
    }
}
class ProfileUpdateTopBar {
    constructor(param) {
        this.param = param;
        this.type = PROFILE_UPDATE_TOP_BAR;
    }
}
class ProfileOpenAssocPrf {
    constructor(assocPrfParams) {
        this.assocPrfParams = assocPrfParams;
        this.type = PROFILE_OPEN_ASSOC;
    }
}

var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["DEV"] = "DEV";
    ENVIRONMENT["UAT"] = "UAT";
    ENVIRONMENT["PDT"] = "PDT";
    ENVIRONMENT["DES"] = "DES";
    ENVIRONMENT["FRT"] = "FRT";
    ENVIRONMENT["MIG"] = "MIG";
    ENVIRONMENT["PRD"] = "PRD";
    ENVIRONMENT["SKL"] = "SKL";
})(ENVIRONMENT || (ENVIRONMENT = {}));

const HTTP_CONFIG_TOKEN = new InjectionToken('http.config');

class HttpConfigService {
    /**
     * Init the http service configuration.
     * @param httpConfig A http configuration
     */
    initConfig(httpConfig) {
        this.config = httpConfig;
    }
    getConfig() {
        return this.config;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Interface for http call
 */
class HttpService {
}
var DacType;
(function (DacType) {
    DacType["warning"] = "W";
    DacType["error"] = "E";
    DacType["info"] = "O";
})(DacType || (DacType = {}));
/**
 * Dac response format.
 */
class DacResponse {
}
/**
 * An error occured calling the DAC service.
 */
class DacErrorResponse {
    constructor(name, error) {
        this.name = name;
        this.error = error;
        this.message = this.error.TEXT;
    }
}

/**Parse response and extract translated resources
 *
 * @param res: response from APFPLUS resources request
 */
const apfExtractResourceData = (res) => {
    const pattern = new RegExp(/\.resourcesDefinition\(([^]*?)\);+(Aria|$)/, 'gm');
    // Local dev || Mobile || Sell Connect
    const body = res.body || res._body || res;
    let matches = pattern.exec(body);
    const result = {};
    while (matches) {
        const atClass = JSON.parse(matches[1]);
        const moduleName = atClass['$classpath'].split('.')[1];
        const resource = atClass['$resources'];
        result[moduleName] = resource;
        matches = pattern.exec(body);
    }
    return result;
};
/**
 * Generate URL to call APFPLUS resources
 * @param apfModules translation modules to retrieve
 * @param session JsessionId
 */
const constructApfPlusResourcesURL = (apfModules, session) => {
    let baseWithAction = '';
    if (session !== undefined && session !== '') {
        baseWithAction = `/apfplus/resources;jsessionid=${session}?`;
    }
    else {
        baseWithAction = `/apfplus/resources?`;
    }
    return `${baseWithAction}module=${apfModules.join('&module=')}`;
};
/**
 * Generate URL to APFPLUS global list
 * @param globalListNames list of global list name
 * @param session JsessionId
 */
const constructApfPlusGlobalsURL = (globalListNames, session) => {
    let baseWithAction = '';
    if (session !== undefined && session !== '') {
        baseWithAction = `/apfplus/globals;jsessionid=${session}?`;
    }
    else {
        baseWithAction = `/apfplus/globals?`;
    }
    return `${baseWithAction}RES=${globalListNames.join('&RES=')}`;
};
const parseDacResponse = (response) => {
    const parsedResponse = new DacResponse();
    if (!response.Output) {
        return parsedResponse;
    }
    let listMessages = [];
    if (listMessageExists(response)) {
        listMessages = response.Output.LIST_MSG;
    }
    else if (listMessageExists(response, 'listMessages')) {
        response.Output.listMessages.forEach((element) => {
            listMessages.push({
                TEXT: String(element.localizedMessage),
                TYPE: String(element.type),
                NUMBER: Number(element.code),
                subMessages: element.subMessages
            });
        });
    }
    if (listMessages.length > 0) {
        listMessages.forEach((element) => {
            if (element.TYPE === DacType.error) {
                throw new DacErrorResponse('DAC_ERROR', element);
            }
            if (element.TYPE === DacType.warning) {
                parsedResponse.warning = parsedResponse.warning || [];
                parsedResponse.warning.push(element);
            }
            if (element.TYPE === DacType.info) {
                parsedResponse.info = parsedResponse.info || [];
                parsedResponse.info.push(element);
            }
        });
    }
    delete response.Output.LIST_MSG;
    delete response.Output.listMessages;
    parsedResponse.success = response.Output;
    parsedResponse.JsessionId = response.JsessionId;
    return parsedResponse;
};
const listMessageExists = (response, listMessageKey = 'LIST_MSG') => response.Output && response.Output[listMessageKey] && response.Output[listMessageKey].length > 0;

class AshService {
    constructor(httpService) {
        this.httpService = httpService;
        this.ASH_API_URL_SUFFIX = '/c/portal/view-solution/';
        this.isAshLinkActivated = false;
        this.ashApiUrl = '';
    }
    init() {
        this.httpService
            .getModuleConfiguration('messages-section')
            .pipe(take(1))
            .subscribe((data) => {
            this.isAshLinkActivated = data.HUG_ASH_CONTEXT_ERR_A;
            this.ashApiUrl = data.ASH_API_URL;
        });
    }
    getAshApiUrl() {
        return this.ashApiUrl + this.ASH_API_URL_SUFFIX;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AshService, deps: [{ token: HttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AshService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AshService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpService }] });

/* Default value for the maximum time in seconds that the retry is applied */
const DEFAULT_TIMEOUT_IN_MS = 10000;
/* Delay between retries in milliseconds */
const DEFAULT_DELAY_BETWEEN_RETRIES_MS = 1000;
/**
 *
 * Retries the Observable in error until Observable completes without error or the timeoutInMs (default: 10 seconds) has expired.
 *
 * A delay (default: 1 second) between each retry attempt is added.
 *
 * @param delayBetweenRetriesInMs
 * @param timeoutInMs
 */
const retryUntil = (timeoutInMs = DEFAULT_TIMEOUT_IN_MS, delayBetweenRetriesInMs = DEFAULT_DELAY_BETWEEN_RETRIES_MS) => (src) => src.pipe(retryWhen((errors) => errors.pipe(delay(delayBetweenRetriesInMs))), timeout(timeoutInMs));

class Analytics {
    constructor(config, httpClient) {
        this.config = config;
        this.httpClient = httpClient;
        this.session = window.crypto.randomUUID();
        this.actionCount = new Map();
        this.analyticsQueue = [];
        this.userData = {};
        this.locked = false;
        this.ANALYTICS_ENDPOINT = config.restURI ?? '/save-frontoffice-data/v1';
        this.maxItemsToSend = config.restItemsLimit ?? 100;
        this.timeout = config.restTimeout ?? 5000;
        this.retryDelay = config.restRetryDelay ?? 1000;
    }
    stopTimer(_action) {
        // Empty function
    }
    setUserData(userData) {
        this.userData = userData;
    }
    track(args) {
        this.analyticsQueue.push({
            category: this.config.keyword,
            analytics: this.getAnalyticsData(args)
        });
        this.sendRequest();
    }
    postAnalyticsData(body) {
        return this.httpClient
            .post(this.ANALYTICS_ENDPOINT, body)
            .pipe(retryUntil(this.timeout, this.retryDelay));
    }
    /**
     * Get analytics data.
     * @param args
     */
    getAnalyticsData(args) {
        this.increaseActionCount(args);
        this.stringifyIntegerActionValue(args);
        const d = args.date || new Date();
        return {
            category: this.config.keyword,
            version: this.config.version,
            logicalSession: this.session,
            action_name: args.action,
            date: d.getTime(),
            dateOffset: d.getTimezoneOffset(),
            deltaTime: args.deltaTime || 0,
            jsessionId: this.userData?.jSessionId || 'none',
            scenarioName: this.config?.scenarioName || 'none',
            action_value: args.action_value || 'none',
            action_count: this.actionCount.get(args.action) || 0,
            agentSign: this.userData?.agentSign || 'none',
            userAlias: this.userData?.userAlias || 'none',
            officeId: this.userData?.loginAreaId || 'none',
            organization: this.userData?.organization || 'none',
            isGuest: this.userData?.isGuest || false,
            language: this.userData?.language || 'none',
            site: this.userData?.site || 'none',
            screen_width: window.screen.width,
            screen_height: window.screen.height,
            freeText: args.freeText || 'none',
            context: args.context || 'none'
        };
    }
    increaseActionCount(args) {
        this.actionCount.set(args.action, (this.actionCount.get(args.action) || 0) + 1);
    }
    stringifyIntegerActionValue(args) {
        if (args.action_value !== null && args.action_value !== undefined && typeof args.action_value !== 'object') {
            args.action_value = String(args.action_value);
        }
    }
    /**
     * Send Analytics to the Analytics Backend.
     * @param data
     * @param onSuccess
     * @param onError
     */
    sendAnalytics(queueData) {
        if (queueData.length !== 0) {
            this.locked = true;
            const formattedData = { data: queueData };
            this.postAnalyticsData(formattedData).subscribe((response) => {
                if (response?.nbProcessedMessages >= 1) {
                    this.locked = false;
                    this.sendRequest();
                }
            }, (error) => {
                if (error.status !== 500) {
                    this.analyticsQueue.push(...queueData);
                }
                this.locked = false;
            });
        }
    }
    /**
     * Send Analytics request.
     */
    sendRequest() {
        if (!this.locked) {
            const elementsToSend = this.getItemsToSend();
            this.sendAnalytics(elementsToSend);
        }
        else if (this.analyticsQueue.length === 0) {
            this.locked = false;
        }
    }
    /**
     * Get the analytics items to be sent with the next request
     */
    getItemsToSend() {
        return this.analyticsQueue.splice(0, this.maxItemsToSend);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Analytics, deps: [{ token: 'analyticsConfig' }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Analytics }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Analytics, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['analyticsConfig']
                }] }, { type: i1$1.HttpClient }] });

/**
 * Interface for Analytics Tracking
 */
class AnalyticsService {
}
/**
 * Analytics arguments that are logged when tracking an action
 */
class AnalyticsArguments {
}
/**
 * Analytics log level
 */
var AnalyticsLogLevel;
(function (AnalyticsLogLevel) {
    AnalyticsLogLevel["INFO"] = "INFO";
    AnalyticsLogLevel["DEBUG"] = "DEBUG";
    AnalyticsLogLevel["TRACE"] = "TRACE";
})(AnalyticsLogLevel || (AnalyticsLogLevel = {}));
/**
 * Probe name's for each task type
 */
var ProbeTaskType;
(function (ProbeTaskType) {
    ProbeTaskType["AIR"] = "air.ng.new";
    ProbeTaskType["PNR"] = "bookingfile.ng.new";
    ProbeTaskType["HOTEL"] = "hotel.ng.new";
    ProbeTaskType["INSURANCE"] = "insurance.ng.new";
    ProbeTaskType["TRANSFERS"] = "transfers.ng.new";
    ProbeTaskType["COMMAND_PAGE"] = "commandpage.ng.new";
    ProbeTaskType["PNR_OPEN"] = "bookingfile.ng.open";
})(ProbeTaskType || (ProbeTaskType = {}));

/**
 * Interface for RSF 1AXML http calls
 */
class Http1AXMLService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLService, decorators: [{
            type: Injectable
        }] });

class Bear1AXMLRSFService extends Bear1AXMLService {
    constructor(http1AXMLService) {
        super();
        this.http1AXMLService = http1AXMLService;
        this.REEF_CONNECT_ENDPOINT = '/cn/api/v2/bear';
    }
    call(endpoint, rq) {
        return this.http1AXMLService
            .post(this.buildUrl(endpoint), rq)
            .pipe(map$1((res) => res.body.model));
    }
    buildUrl(serviceName) {
        return `${this.REEF_CONNECT_ENDPOINT}/${serviceName}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLRSFService, deps: [{ token: Http1AXMLService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLRSFService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLRSFService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: Http1AXMLService }] });

class Bear1AXMLServiceMock extends Bear1AXMLService {
    call(endpoint, rq) {
        return of({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLServiceMock, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLServiceMock }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Bear1AXMLServiceMock, decorators: [{
            type: Injectable
        }] });

class QueueService {
    constructor() {
        this.queue = [];
        this.queueLocked = false;
    }
    addRequest(service) {
        const subject = new Subject();
        this.queue.push({ service, subject });
        this.invoke();
        return subject.asObservable();
    }
    invoke() {
        if (this.queue.length === 0 || this.queueLocked) {
            return;
        }
        this.queueLocked = true;
        const request = this.queue.shift();
        request.service
            .pipe(finalize(() => {
            this.queueLocked = false;
            this.invoke();
        }))
            .subscribe({
            next: (res) => {
                request.subject.next(res);
                request.subject.complete();
            },
            error: (err) => {
                request.subject.error(err);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QueueService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QueueService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QueueService, decorators: [{
            type: Injectable
        }] });

/**
 * Service for clp authorization http calls.
 * The service executes clp requests sequentially to prevent collisions.
 */
class ClpAuthService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.queue = new QueueService();
    }
    /**
     * Http GET request for the clp authorization endpoint
     * @param {string} url clp endpoint
     * @returns {Observable<string>} ash authorization token observable
     */
    getClpAuthRequest(url) {
        return this.queue.addRequest(this.httpClient.get(url, { withCredentials: true, responseType: 'text' }).pipe(map((res) => this.parseIdToken(res)), catchError(this.handleError)));
    }
    /**
     * Parses the clp html response to retrieve the id token
     * @param htmlResponse
     */
    parseIdToken(htmlResponse) {
        const domParser = new DOMParser();
        if (htmlResponse) {
            try {
                return (domParser.parseFromString(htmlResponse, 'text/html').getElementsByTagName('input').namedItem('id_token')?.['value'] ?? null);
            }
            catch (error) {
                console.error('Clp authorization id_token parsing failed.', error);
                return null;
            }
        }
        else {
            console.error('Cannot parse an empty clp authorization.');
            return null;
        }
    }
    handleError(error) {
        return throwError(() => error);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpAuthService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }] });

/**
 * Abstract service implemented in seco-ngloader to return information from SECO context
 * Example of context information: User info, task context...
 *
 */
class ContextService {
}

class TaskTokenService {
    constructor() {
        /**
         * Configuration for Task
         *
         * taskId = 'main' || 's1'
         */
        this.task$ = new BehaviorSubject('');
    }
    updateTask(taskId) {
        this.task$.next(taskId);
    }
    getTask() {
        return this.task$.asObservable();
    }
    getTaskValue() {
        return this.task$.getValue();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TaskTokenService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TaskTokenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TaskTokenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CrypticUtilService {
    constructor(bear) {
        this.bear = bear;
        this.MAX_SCROLL = 20;
        this.SCROLL_CMD = 'MD';
        this.SCROLL_INDICATOR = ')>';
        this.COMMAND_INDICATOR = '>';
    }
    /**
     * Sends cryptic command followed by scroll, upto a MAX_SCROLL count
     * @param command The initial command to be executed
     * @returns string with responses cleaned and appended
     */
    sendCrypticCommand(command) {
        const replies = [];
        return from([command].concat(Array(this.MAX_SCROLL).fill(this.SCROLL_CMD))).pipe(concatMap((str) => this.bear.commandCryptic(this.getQuery(str))), takeWhile((response) => this.hasNextCommand(response) && replies.length < this.MAX_SCROLL, true), map$1((response) => {
            replies.push(this.clearResponse(response));
            if (!this.hasNextCommand(response) || replies.length === this.MAX_SCROLL) {
                return replies.join('\n');
            }
            return undefined;
        }), filter((data) => data !== undefined));
    }
    hasNextCommand(reply) {
        return reply?.longTextString?.textStringDetails?.endsWith(this.SCROLL_INDICATOR) || false;
    }
    clearResponse(response) {
        if (this.hasNextCommand(response) ||
            response?.longTextString?.textStringDetails?.endsWith(this.COMMAND_INDICATOR)) {
            const reply = response?.longTextString?.textStringDetails?.split('\n');
            if (reply !== undefined) {
                reply.pop();
                return reply.join('\n');
            }
        }
        else if (response?.longTextString?.textStringDetails) {
            return response?.longTextString?.textStringDetails;
        }
        return '';
    }
    getQuery(command) {
        return {
            messageAction: {
                messageFunctionDetails: {
                    messageFunction: 'M'
                }
            },
            longTextString: {
                textStringDetails: command
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CrypticUtilService, deps: [{ token: i1$2.Bear1AXMLService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CrypticUtilService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CrypticUtilService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Bear1AXMLService }] });

/**
 * Date mode for custom parsing/formating
 * FUTURE_DATE: itinerary search
 * PAST_DATE: date of birth
 */
var DateMode;
(function (DateMode) {
    DateMode["FUTURE_DATE"] = "FUTURE_DATE";
    DateMode["PAST_DATE"] = "PAST_DATE";
    DateMode["MIXED_DATE"] = "MIXED_DATE";
})(DateMode || (DateMode = {}));

/**
 * Use class for NgbDateParserFormatter to use IATA date formats in Date Picker (NgDateStruct)
 *
 * Provide DATE_MODE to change Date mode for custom parsing/formating
 * FUTURE_DATE
 * PAST_DATE
 * MIXED_DATE
 */
class NgbDateIataFormatter extends NgbDateParserFormatter {
    constructor(mode) {
        super();
        this.mode = mode;
        this.monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        this.dateMode = mode || DateMode.FUTURE_DATE;
    }
    /**
     * a date string with the format ddMMMyy ex 03JAN20 - IATA
     * is accepted and converted into an NgDateStruct by this parser
     *
     * @param value
     */
    parse(value) {
        if (!value) {
            return null;
        }
        const rawDay = value.substring(0, 2);
        const rawDayNr = parseInt(rawDay, 10);
        const rawMonth = value.substring(2, 5);
        const monthNr = this.monthNames.indexOf(rawMonth.toUpperCase());
        const rawYear = value.substring(5);
        const rawYearNr = this.normalizeYearValue(rawYear);
        if (monthNr <= -1 || isNaN(rawDayNr)) {
            return null;
        }
        if (!isNaN(rawYearNr) && (rawYear.length === 2 || rawYear.length === 4) && rawDay.length === 2) {
            return { day: rawDayNr, month: monthNr + 1, year: this.getFullYear(rawYear) };
        }
        else if (rawYear.length === 0) {
            const yearResult = this.computeYear(monthNr, rawDayNr);
            return { day: rawDayNr, month: monthNr + 1, year: yearResult };
        }
        return null;
    }
    /**
     * returns a string with the format ddMMMyyyy ex 03JAN20 - IATA
     *
     * @param date
     */
    format(date) {
        if (date) {
            return ('0' + date.day).slice(-2) + this.monthNames[date.month - 1] + date.year.toString(10).slice(-2);
        }
        else {
            return '';
        }
    }
    /**
     * Takes year param with length of 2 (ex: 18) or 4 (ex: 2018)
     * Returns 4 digits year from 2 digits based on date mode and current year
     * @param yearStr string representing the year
     */
    getFullYear(yearStr) {
        if (yearStr.length !== 2) {
            return Number(yearStr);
        }
        const year = this.normalizeYearValue(yearStr);
        if (this.dateMode === DateMode.FUTURE_DATE || this.dateMode === DateMode.MIXED_DATE) {
            // search mode -> always use 20yy
            return 2000 + year;
        }
        else {
            // date of birth -> if 20yy in the future use 19yy
            const yearsDiff = 2000 + year - new Date().getFullYear();
            return (yearsDiff > 0 ? 1900 : 2000) + year;
        }
    }
    /**
     * This function takes as input a string representing a year, which can have a length of 2 (ex: 18) or 4 (ex: 2018).
     * This function will return a 2 digits number representing the year ('2018' & '18' would return 18)
     * and return undefined if year input is invalid string like 12Aug0b/12Augbb/12Augb0
     * @param yearStr string representing the year to normalize
     */
    normalizeYearValue(yearStr) {
        // if (this.dateMode === DateMode.MIXED_DATE && isNaN(Number(yearStr))) {
        //   return undefined;
        // }
        if (yearStr.length === 4) {
            yearStr = yearStr.substring(2, 4);
        }
        return parseInt(yearStr, 10);
    }
    computeYear(monthNr, rawDayNr) {
        const today = this.getTodaysDate();
        if (monthNr >= today.getMonth() && (monthNr !== today.getMonth() || rawDayNr >= today.getDate())) {
            return today.getFullYear();
        }
        else {
            return this.dateMode === DateMode.MIXED_DATE ? today.getFullYear() : today.getFullYear() + 1;
        }
    }
    getTodaysDate() {
        return new Date();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NgbDateIataFormatter, deps: [{ token: 'DATE_MODE', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NgbDateIataFormatter }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NgbDateIataFormatter, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: DateMode, decorators: [{
                    type: Inject,
                    args: ['DATE_MODE']
                }, {
                    type: Optional
                }] }] });

const LANGUAGE_CODE_MAP = new Map([
    ['de', LanguageCode['DE_DE']],
    ['en-GB', LanguageCode['EN_GB']],
    ['en-US', LanguageCode['EN_US']],
    ['es', LanguageCode['ES_ES']],
    ['zh-Hant', LanguageCode['ZH_TW']],
    ['zh', LanguageCode['ZH_CN']],
    ['fr', LanguageCode['FR_FR']],
    ['ko', LanguageCode['KO_KR']],
    ['it', LanguageCode['IT_IT']],
    ['ja', LanguageCode['JA_JP']],
    ['pt', LanguageCode['PT_BR']],
    ['ru', LanguageCode['RU_RU']]
]);

class EquipmentMapCacheUtil {
    /**
     * Get all equipment codes not cached yet
     *
     * @param equipmentCodes All equipment codes
     * @param equipments The equipments map
     * @returns All equipment codes not cached yet
     *
     */
    static getEquipmentsNotCached(equipmentCodes, equipments) {
        return equipmentCodes.filter((key) => !equipments.has(key));
    }
    /**
     * Get the specified equipments from cache
     *
     * @param equipmentCodes The wanted equipment codes
     * @param equipments The equipments map cached
     * @returns The equipments map from cache
     *
     */
    static getEquipmentsFromCache(equipmentCodes, equipments) {
        const matchedEquipments = new Map();
        equipmentCodes.forEach((code) => {
            if (equipments.get(code)) {
                matchedEquipments.set(code, equipments.get(code) ?? '');
            }
        });
        return matchedEquipments;
    }
}
class EquipmentsService {
    constructor(locale, rfdService) {
        this.locale = locale;
        this.rfdService = rfdService;
        this.equipmentsMap = new Map();
        this.languageCode = LANGUAGE_CODE_MAP.get(this.locale) ?? LanguageCode['EN_US'];
    }
    /**
     * Load equipments map
     * @param equipmentCodes list of equipment codes
     * @returns an Observable of Map of equipment code and type
     */
    loadEquipments(equipmentCodes) {
        if (!equipmentCodes?.length) {
            return of(new Map());
        }
        const equipmentCodesNotCached = EquipmentMapCacheUtil.getEquipmentsNotCached(equipmentCodes, this.equipmentsMap);
        if (equipmentCodesNotCached.length === 0) {
            return of(EquipmentMapCacheUtil.getEquipmentsFromCache(equipmentCodes, this.equipmentsMap));
        }
        else {
            return this.rfdService.getEquipmentByCodes(this.languageCode, undefined, equipmentCodesNotCached).pipe(map((equipmentResponse) => {
                equipmentResponse?.forEach((response) => {
                    if (response.equipmentCode && response.equipmentType) {
                        this.equipmentsMap.set(response.equipmentCode, response.equipmentType);
                    }
                });
                return EquipmentMapCacheUtil.getEquipmentsFromCache(equipmentCodes, this.equipmentsMap);
            }));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: EquipmentsService, deps: [{ token: LOCALE_ID }, { token: i1$3.RFDService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: EquipmentsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: EquipmentsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i1$3.RFDService }] });

class LocalStorageService {
    /**
     * Set an item in the local storage.
     * @param key
     * @param value
     */
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    /**
     * Get an item of the local storage.
     * @param key
     */
    getItem(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    /**
     * Remove an item of the local storage.
     * @param key
     */
    removeItem(key) {
        localStorage.removeItem(key);
    }
    /**
     * Clear the local storage.
     */
    clear() {
        localStorage.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LocalStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LocalStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class PnrAccParser {
    static extractPnrAccErrors(response) {
        let errors = [];
        response?.generalErrorInfo?.forEach((errorInfo) => {
            // Skip error 15 because that means that we tried reretrieve but we don't have pnr in session
            if (errorInfo?.errorOrWarningCodeDetails?.errorDetails?.errorCode !== PNRRET_ERROR_PNR_SESSION) {
                const errorMessages = errorInfo?.errorWarningDescription?.freeText;
                errors.push({
                    type: PnrAccParser.getMessageType(errorInfo?.errorOrWarningCodeDetails?.errorDetails?.errorCategory || ''),
                    code: Number.parseInt(errorInfo?.errorOrWarningCodeDetails?.errorDetails?.errorCode || '', 10),
                    message: errorMessages ? errorMessages.join(' ') : ''
                });
            }
        });
        errors = [...errors, ...PnrAccParser.extractPnrAccTravellerErrors(response)];
        return errors;
    }
    static extractPnrAccTravellerErrors(response) {
        const errors = [];
        response?.travellerInfo?.forEach((travellerInfo) => {
            if (travellerInfo?.nameError?.errorOrWarningCodeDetails) {
                const errorMessages = travellerInfo.nameError.errorWarningDescription?.freeText;
                errors.push({
                    type: PnrAccParser.getMessageType(travellerInfo.nameError.errorOrWarningCodeDetails.errorDetails?.errorCategory || ''),
                    code: Number.parseInt(travellerInfo.nameError.errorOrWarningCodeDetails.errorDetails?.errorCode || '', 10),
                    message: errorMessages ? errorMessages.join(' ') : ''
                });
            }
        });
        return errors;
    }
    static getMessageType(messageCategory) {
        return PnrRetErrorMapping[messageCategory] || MessageType.ERROR;
    }
}

class CustomizationOrchestratorService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CustomizationOrchestratorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CustomizationOrchestratorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CustomizationOrchestratorService, decorators: [{
            type: Injectable
        }] });

class QualityMonitorService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QualityMonitorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QualityMonitorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: QualityMonitorService, decorators: [{
            type: Injectable
        }] });

class ReactiveFormUtilsService {
    /**
     * Mark as dirty all controls of a form.
     * @param group
     */
    markAsDirtyForm(group) {
        group.markAsDirty();
        for (const control of Object.values(group.controls)) {
            if (control instanceof UntypedFormControl) {
                control.markAsDirty();
            }
            else {
                this.markAsDirtyForm(control);
            }
        }
    }
    /**
     * Mark as untouched all controls of a form.
     * @param group
     */
    markAsUntouchedForm(group) {
        group.markAsUntouched();
        for (const control of Object.values(group.controls)) {
            if (control instanceof UntypedFormControl) {
                control.markAsUntouched();
            }
            else {
                this.markAsUntouchedForm(control);
            }
        }
    }
    /**
     * Validator to check that the value of each controls are similar in a form group.
     * @param group
     */
    allEqualInGroupValidator(group) {
        let val;
        let valid = true;
        for (const name in group.controls) {
            if (val === undefined) {
                val = group.controls[name].value;
            }
            else {
                if (val !== group.controls[name].value) {
                    valid = false;
                    break;
                }
            }
        }
        if (valid) {
            return null;
        }
        return {
            allEqualInGroupValidator: true
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReactiveFormUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReactiveFormUtilsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReactiveFormUtilsService, decorators: [{
            type: Injectable
        }] });

/**
 * Interact with the REEF Configuration server part.
 */
// @dynamic
class ReefConfigurationService {
    constructor(httpClient, window) {
        this.httpClient = httpClient;
        this.window = window;
        this.CONFIGURATION_BASE_URL = '/cf/api/v1';
        this.OVERRIDE_PARAMETER_KEY = 'ovParameter';
        this.GET_PARAMETERS_ACTION = 'parameters';
        this.QUESTION_MARK = '?';
    }
    /**
     * Calls REEF Configuration endpoint GET /parameters?moduleName=moduleName adding module name and override parameters in the GET request
     * @param moduleName
     * @returns The module configuration
     */
    getConfiguration(moduleName) {
        const params = this.buildGetConfigurationQueryParameters(moduleName);
        return this.httpClient.get(`${this.CONFIGURATION_BASE_URL}/${this.GET_PARAMETERS_ACTION}`, {
            params
        });
    }
    /**
     * Builds query parameters using module name and potential URL parameter overrides
     * @param moduleName
     * @returns Query parameters to be sent in the GET request
     */
    buildGetConfigurationQueryParameters(moduleName) {
        const options = { fromObject: { moduleName } };
        const overrideParameters = this.getOverrideParameters();
        if (overrideParameters.length > 0) {
            options.fromObject[this.OVERRIDE_PARAMETER_KEY] = overrideParameters;
        }
        return new HttpParams(options);
    }
    /**
     * Get the list of parameter overrides from the URL. It looks at both URL query & hash string.
     * Examples:
     *   - ?ovParameter=PARAM_1=true&LANGUAGE=GB -> ["PARAM_1=true"]
     *   - ?ovParameter=PARAM_1=true&ovParameter=PARAM_2=false -> ["PARAM_1=true", PARAM_2=false]
     *   - #dashbord?ovParameter=PARAM_1=true&ovParameter=PARAM_2=false -> ["PARAM_1=true", PARAM_2=false]
     * @returns List of strings containing all parameter overrides
     */
    getOverrideParameters() {
        // check standard query parameter
        let overrideParameters = this.parseOverrideParameters(this.window.location.search);
        // check for parameter override in hash
        const hash = this.window.location.hash;
        if (hash.indexOf(this.QUESTION_MARK) > -1) {
            overrideParameters = overrideParameters.concat(this.parseOverrideParameters(hash.split(this.QUESTION_MARK)[1]));
        }
        return overrideParameters;
    }
    /**
     * It parses the given string and returns an array of override parameters
     * @param overrideQueryParameters
     * @param location Either the URL query or hash string
     */
    parseOverrideParameters(location) {
        const overrideParameters = [];
        new URLSearchParams(location).forEach((value, key) => {
            if (key === this.OVERRIDE_PARAMETER_KEY) {
                overrideParameters.push(value);
            }
        });
        return overrideParameters;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefConfigurationService, deps: [{ token: i1$1.HttpClient }, { token: Window }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefConfigurationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefConfigurationService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: Window }] });

const JWT_TYPE_NAME = 'Bearer';
var ReefHeaders;
(function (ReefHeaders) {
    ReefHeaders["AUTH"] = "Authorization";
    ReefHeaders["TRACING"] = "Reef-Tracing-Id";
})(ReefHeaders || (ReefHeaders = {}));

class ReefTokenService {
    setTokens(newTokens) {
        this.tokens = newTokens;
    }
    getTokens() {
        return this.tokens;
    }
    generateHeaders() {
        const tokens = this.tokens;
        if (!tokens) {
            return {};
        }
        return Array.from(tokens.keys()).reduce((acc, headerName) => {
            const headerValues = tokens.get(headerName);
            acc[headerName] = Array.from(headerValues.keys())
                .map(type => {
                const value = headerValues.get(type);
                if (type !== '') {
                    return `${type} ${value}`;
                }
                return value;
            })
                .join(', ');
            return acc;
        }, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenService, decorators: [{
            type: Injectable
        }] });

const GATEWAY_BASE_URL = '/gw/api';
const GATEWAY_AUTH_URI = '/auth';
const GATEWAY_LSS_URI = '/lss/node';
const GATEWAY_DEFAULT_VERSION = 'v3';
const urlencodedHttpOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8'),
    withCredentials: true
};
const jsonHttpOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true
};
var Audience;
(function (Audience) {
    Audience["SNOW"] = "ASCSP";
})(Audience || (Audience = {}));
var NodeType;
(function (NodeType) {
    NodeType["OFFICE"] = "OFFICE";
    NodeType["ORGANISATION"] = "ORGANISATION";
    NodeType["OGU_ORGANISATION"] = "OGU_ORGANISATION";
})(NodeType || (NodeType = {}));
/**
 * Interact with the REEF Gateway server part. To be able to use it in a product, an Apache configuration is needed.
 */
class ReefGatewayService {
    constructor() {
        this.AUTH_TOKEN_ACTION = 'clpConfig';
        this.LOG_IN_ACTION = 'authenticate';
        this.LOG_OUT_ACTION = 'logout';
        this.RENEW_TOKEN_ACTION = 'renewToken';
        this.ACL_ACTION = 'acl';
        this.RENEW_REEF_ACCESS_TOKEN = 'renewAccessToken';
        this.REFERENTIAL_DATA_ACTION = 'rfd';
        this.version = GATEWAY_DEFAULT_VERSION;
        this.permissions = { map: {} };
        this.httpClient = inject(HttpClient);
        this.tokenService = inject(ReefTokenService);
        this.httpService = inject(HttpService, { optional: true });
    }
    /**
     * Retrieve referential data of the logged user from gateway server
     * expected result: map containing first name (FIN) and last name (LSN)
     */
    getReferentialData() {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.REFERENTIAL_DATA_ACTION}`, urlencodedHttpOptions);
    }
    setVersion(version) {
        this.version = version ?? GATEWAY_DEFAULT_VERSION;
    }
    getAuthenticationToken() {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.AUTH_TOKEN_ACTION}`, urlencodedHttpOptions);
    }
    loginInByAccessToken(loginInput) {
        const body = new HttpParams().set('data', JSON.stringify(loginInput));
        return this.httpClient
            .post(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.LOG_IN_ACTION}`, body, urlencodedHttpOptions)
            .pipe(map$1((res) => {
            if (!res.jwt) {
                throw new Error('[SUITS ERROR] GatewayService loginInByAccessToken should return a jwt to be used by the ReefServer module');
            }
            this.tokenService.setTokens(new Map([[ReefHeaders.AUTH, new Map([[JWT_TYPE_NAME, res.jwt]])]]));
            this.permissions = { map: res.Permissions };
            res.Output.JsessionId = res.JsessionId;
            return res.Output;
        }));
    }
    logout() {
        return this.httpClient
            .get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.LOG_OUT_ACTION}`, urlencodedHttpOptions)
            .pipe(tap(() => {
            this.tokenService.setTokens();
        }));
    }
    loginInThroughJCP(loginInput = {}) {
        if (!this.httpService) {
            throw new Error('[SUITS ERROR] GatewayService HttpService has to be imported to use loginInThroughJCP endpoint');
        }
        return this.httpService.postDac('jwt', loginInput).pipe(map$1((res) => {
            if (!res.success?.jwt) {
                throw new Error('[SUITS ERROR] GatewayService loginInByAccessToken should return a jwt to be used by the ReefServer module');
            }
            this.tokenService.setTokens(new Map([
                [ReefHeaders.AUTH, new Map([[JWT_TYPE_NAME, res.success.jwt]])],
                [ReefHeaders.TRACING, new Map([['', res.JsessionId]])]
            ]));
            if (res.success.permissions) {
                this.permissions = { map: res.success.permissions };
            }
            return res.success.jwt;
        }));
    }
    renewToken() {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.RENEW_TOKEN_ACTION}`, urlencodedHttpOptions);
    }
    renewReefAccessToken() {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.RENEW_REEF_ACCESS_TOKEN}`, urlencodedHttpOptions);
    }
    getPermissions() {
        return this.permissions;
    }
    getACL(permissions) {
        return this.httpClient.post(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/${this.ACL_ACTION}`, permissions, jsonHttpOptions);
    }
    exchangeToken(audience) {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_AUTH_URI}/exchange-token?audience=${audience}`, jsonHttpOptions);
    }
    getLSSHierarchyNode(nodeType, nodeName) {
        return this.httpClient.get(`${GATEWAY_BASE_URL}/${this.version}${GATEWAY_LSS_URI}/${nodeType}/${nodeName}/children`, jsonHttpOptions);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefGatewayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefGatewayService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefGatewayService, decorators: [{
            type: Injectable
        }] });

class ReefKeepAliveService {
    constructor(zone, gwService) {
        this.zone = zone;
        this.gwService = gwService;
        // Expiration time of JWT token and LSS access token is 15min
        // 10 minutes in ms
        this.TIME_INTERVAL = 60 * 10 * 1000;
        // 2 minutes in ms
        this.RETRY_TIME = 60 * 2 * 1000;
        // Number of retry
        this.MAX_RETRY = 2;
        this.isErrorCatched = false;
    }
    start() {
        this.stop();
        this.zone.runOutsideAngular(() => {
            this.keepAliveCb = setInterval(() => {
                this.zone.run(() => {
                    this.renewToken();
                });
            }, this.TIME_INTERVAL);
        });
    }
    stop() {
        if (this.keepAliveCb) {
            clearInterval(this.keepAliveCb);
            this.keepAliveCb = undefined;
            this.isErrorCatched = false;
            if (this.subs) {
                this.subs.unsubscribe();
            }
        }
    }
    reset() {
        if (this.keepAliveCb) {
            this.start();
        }
    }
    renewToken() {
        let retries = this.MAX_RETRY;
        this.subs = this.gwService
            .renewToken()
            .pipe(retryWhen((errors) => errors.pipe(tap(() => {
            this.isErrorCatched = true;
        }), delay(this.RETRY_TIME), mergeMap((error) => {
            if (retries-- > 0) {
                return of(error);
            }
            return throwError(error);
        }))), catchError$1(() => {
            this.stop();
            return EMPTY;
        }))
            .subscribe(() => {
            if (this.isErrorCatched) {
                this.reset();
            }
        });
    }
    ngOnDestroy() {
        this.stop();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefKeepAliveService, deps: [{ token: i0.NgZone }, { token: ReefGatewayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefKeepAliveService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefKeepAliveService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: ReefGatewayService }] });

class URLUtils {
    static { this.reefServerEndpoint = [
        '/gw/',
        '/cn/',
        '/na/',
        '/ps/',
        '/cf/',
        '/as/',
        '/af/',
        '/rt/',
        '/ra/',
        '/ga/',
        '/ht/',
        '/ex/'
    ]; }
    static isREEFServerEndpoint(url) {
        return !!this.reefServerEndpoint.find((endpoint) => url.startsWith(endpoint) || url.match(`${window.location.hostname}${endpoint}`));
    }
    static isSNOWEndpoint(url) {
        return url.includes('service-now') && url.includes('connectnow');
    }
}

class ReefTokenInterceptor {
    constructor(reefTokenService, keepAliveService) {
        this.reefTokenService = reefTokenService;
        this.keepAliveService = keepAliveService;
    }
    intercept(request, next) {
        const tokens = this.reefTokenService.getTokens();
        const shouldBeIntercepted = !!tokens && URLUtils.isREEFServerEndpoint(request.url);
        if (shouldBeIntercepted) {
            request = request.clone({
                setHeaders: this.reefTokenService.generateHeaders()
            });
        }
        return next.handle(request).pipe(map$1((event) => {
            this.handleResponseOrError(shouldBeIntercepted, event);
            return event;
        }), catchError$1((err) => {
            this.handleResponseOrError(shouldBeIntercepted, err);
            return throwError(() => err);
        }));
    }
    handleResponseOrError(shouldBeIntercepted, event) {
        if (shouldBeIntercepted &&
            (event instanceof HttpResponse || event instanceof HttpErrorResponse) &&
            event.headers.has(ReefHeaders.AUTH)) {
            const responseJwtToken = event.headers.get(ReefHeaders.AUTH).split(`${JWT_TYPE_NAME} `);
            if (responseJwtToken.length === 2) {
                const authTokens = this.reefTokenService.getTokens()?.get(ReefHeaders.AUTH);
                if (authTokens) {
                    authTokens.set(JWT_TYPE_NAME, responseJwtToken[1]);
                    this.keepAliveService.reset();
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenInterceptor, deps: [{ token: ReefTokenService }, { token: ReefKeepAliveService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefTokenInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: ReefTokenService }, { type: ReefKeepAliveService }] });

class OverrideInterceptor {
    constructor(httpConfig) {
        this.httpConfig = httpConfig;
    }
    intercept(request, next) {
        const config = this.httpConfig.getConfig();
        if (config?.environment && URLUtils.isREEFServerEndpoint(request.url)) {
            return next.handle(request.clone({
                params: (request.params ?? new HttpParams()).set('OCTX', config.environment)
            }));
        }
        return next.handle(request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideInterceptor, deps: [{ token: HttpConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: HttpConfigService }] });

const httpOptions$2 = { withCredentials: true };
/**
 * Service to call REST Backend API using REEF Servers.
 */
class ReefRESTService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.REEF_CONNECT_ENDPOINT = '/cn/api/v2/usap';
    }
    get(serviceName, params) {
        return this.httpClient.get(this.buildUrl(serviceName), { ...httpOptions$2, params });
    }
    post(serviceName, body, params, headers) {
        return this.httpClient.post(this.buildUrl(serviceName), body, { ...httpOptions$2, params, headers });
    }
    put(serviceName, body, headers) {
        return this.httpClient.put(this.buildUrl(serviceName), body, { ...httpOptions$2, headers });
    }
    delete(serviceName, body, headers) {
        return this.httpClient.delete(this.buildUrl(serviceName), { ...httpOptions$2, body, headers });
    }
    patch(serviceName, body, params) {
        return this.httpClient.patch(this.buildUrl(serviceName), body, { ...httpOptions$2, params });
    }
    buildUrl(serviceName) {
        return `${this.REEF_CONNECT_ENDPOINT}/${serviceName}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefRESTService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefRESTService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefRESTService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }] });

const API_GATEWAY_ENABLED_DEFAULT_MODULES = '';
/**
 * Interact with the REEF Gateway server part. To be able to use it in a product, an Apache configuration is needed.
 */
class ReefApiGatewayService {
    constructor() {
        this.defaultModules = API_GATEWAY_ENABLED_DEFAULT_MODULES;
    }
    setApiGwEnabledModules(defaultModules) {
        this.defaultModules = defaultModules ?? API_GATEWAY_ENABLED_DEFAULT_MODULES;
    }
    getApiGwEnabledModules() {
        return this.defaultModules;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefApiGatewayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefApiGatewayService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefApiGatewayService, decorators: [{
            type: Injectable
        }] });

class OverrideReefApiGwReqInterceptor {
    constructor(reefApiGatewayService) {
        this.reefApiGatewayService = reefApiGatewayService;
        this.gwEnabledModulesList = this.reefApiGatewayService.getApiGwEnabledModules().split(',');
    }
    intercept(request, next) {
        const endpoint = this.gwEnabledModulesList.find((key) => this.isMatchingEndpoint(key, request.url));
        let modifiedRequest = request;
        if (endpoint) {
            const modifiedUrl = request.url.replace(endpoint, `/ag${endpoint}`);
            modifiedRequest = request.clone({ url: modifiedUrl });
        }
        return next.handle(modifiedRequest);
    }
    isMatchingEndpoint(key, url) {
        return url.startsWith(key) || url.includes(`${window.location.hostname}${key}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideReefApiGwReqInterceptor, deps: [{ token: ReefApiGatewayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideReefApiGwReqInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OverrideReefApiGwReqInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: ReefApiGatewayService }] });

class ReefServerModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('[SUITS ERROR] ReefServerModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot() {
        return {
            ngModule: ReefServerModule,
            providers: [
                ReefGatewayService,
                ReefTokenService,
                ReefRESTService,
                ReefKeepAliveService,
                ReefConfigurationService,
                ReefApiGatewayService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: ReefTokenInterceptor,
                    multi: true,
                    deps: [ReefTokenService, ReefKeepAliveService]
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: OverrideInterceptor,
                    multi: true
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: OverrideReefApiGwReqInterceptor,
                    multi: true
                },
                { provide: Window, useValue: window }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefServerModule, deps: [{ token: ReefServerModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ReefServerModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefServerModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefServerModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: () => [{ type: ReefServerModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

/**
 * Service responsible for renewing the Reef access token at regular intervals.
 */
class RenewReefAccessTokenService {
    constructor() {
        this.TIME_INTERVAL = 10 * 60 * 1000;
        this.gwService = inject(ReefGatewayService);
        this.tokenKeepAliveService = inject(ReefKeepAliveService);
    }
    resetRenewalTimer() {
        this.stopInterval();
        this.startRenewalTimer();
    }
    renewReefAccessToken() {
        this.tokenKeepAliveService.reset();
        this.gwService.renewReefAccessToken().subscribe();
    }
    ngOnDestroy() {
        this.stopInterval();
    }
    startRenewalTimer() {
        this.renewalTimer = setInterval(() => {
            this.renewReefAccessToken();
        }, this.TIME_INTERVAL);
    }
    stopInterval() {
        clearInterval(this.renewalTimer);
        this.renewalTimer = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RenewReefAccessTokenService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RenewReefAccessTokenService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RenewReefAccessTokenService, decorators: [{
            type: Injectable
        }] });

const httpOptions$1 = { withCredentials: true, observe: 'response' };
class Http1AXMLServiceImpl extends Http1AXMLService {
    constructor(httpClient, queue) {
        super();
        this.httpClient = httpClient;
        this.queue = queue;
    }
    post(endpoint, rq, headers) {
        if (headers) {
            return this.queue.addRequest(this.httpClient.post(endpoint, rq, { ...httpOptions$1, headers }));
        }
        return this.queue.addRequest(this.httpClient.post(endpoint, rq, httpOptions$1));
    }
    get(endpoint, headers) {
        if (headers) {
            return this.queue.addRequest(this.httpClient.get(endpoint, { ...httpOptions$1, headers }));
        }
        return this.queue.addRequest(this.httpClient.get(endpoint, httpOptions$1));
    }
    delete(endpoint, headers) {
        if (headers) {
            return this.queue.addRequest(this.httpClient.delete(endpoint, { ...httpOptions$1, headers }));
        }
        return this.queue.addRequest(this.httpClient.delete(endpoint, httpOptions$1));
    }
    put(endpoint, rq, headers) {
        if (headers) {
            return this.queue.addRequest(this.httpClient.put(endpoint, rq, { ...httpOptions$1, headers }));
        }
        return this.queue.addRequest(this.httpClient.put(endpoint, rq, httpOptions$1));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLServiceImpl, deps: [{ token: i1$1.HttpClient }, { token: QueueService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLServiceImpl }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: Http1AXMLServiceImpl, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: QueueService }] });

const ACCEPTED_CREDIT_CARDS = {
    visa: /^4\d{12}(?:\d{3})?(?:\d{2,3})?$/,
    mastercard: /^5[1-5]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/,
    amex: /^3[47]\d{13}$/,
    discover: /^(?:65[4-9]\d{13}|64[4-9]\d{13}|6011\d{12}|(622(?:12[6-9]|1[3-9]\d|[2-8]\d\d|9[01]\d|92[0-5])\d{10}))$/,
    diners_club: /^3(?:0[0-5]|[68]\d)\d{11}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    dankort: /^5019(?:[- ]?\d{4}){3}/,
    interpayment: /^636\d(?:[- ]?\d{4}){3}/,
    uatp: /^1\d{3}[- ]?\d{5}[- ]?\d{6}/,
    maestro1: /^(?:5[0678]\d{2}|6\d{3})[- ]?\d{4}[- ]?\d{5}/,
    maestro2: /^(?:5[0678]\d{2}|6\d{3})[- ]?\d{6}[- ]?\d{5}/,
    maestro3: /^(?:5[0678]\d{2}|6\d{3})(?:[- ]?\d{4}){3}/,
    maestro4: /^(?:5[0678]\d{2}|6\d{3})(?:[- ]?\d{4}){3}[- ]?\d{3}/,
    airplus: /^(?:1920|1220|1086)\d{10}/,
    hiperCar: /^(?:(606282\d{10}(\d{3})?)|(3841[046]0\d{13}))$/
};
/**
 * If a value matches the regexp, then it is NOT concealed.
 */
const WHITELIST_REGEX = /\b(?:RAILCARD-|TKNE|TKNM|RETKT|TKT-)\b/;
/**
 * CVV regex used for replacing CVC/CVV/...
 */
const REGEX_CVV = /(?:\*CV(\d{3,4}))/d;
/**
 * String values (that are not numbers) are concealed only if they match this regex (Cryptic Request).
 */
const CRYPTIC_REQUEST_BLACKLIST = /^\s*(?:SR\s+(?:FOID|EPAY)|FP|IS|IMCM|RM|RC|R[XYIQ]|\/(?:G|DP|CC))/;
class CreditCardConcealmentService {
    constructor() {
        this.hiperCardRegExp = new RegExp(/^(606282[0-9]{10}([0-9]{3})?)|(3841(0|4|6)0[0-9]{13})$/);
        /**
         * List of the commands that can't be followed by credit card numbers
         */
        this.regexpNotCCCmd = new RegExp('^((RY)|(HU)|(RU)|(FZ)|(TWD)|(RX)|(DE)|(RPP)|(I-SB)|(RC)|(TSM)|(AP)|(BD)|(RM)|(OS)|(FH)|' +
            '(SR)|(FF[NnAaRrUu][:alpha:]{2})|(FX)|(TL)|(TKT)|(CD)|(BN)|(BR)|(CF)|(PH)|(FT)|(ID)|(QU)|(\\*\\*))', 'i');
        /**
         * Credit card regular expression
         */
        this.regexpCC = new RegExp('(?:(((?:(?:[0-9]{4}[- ]){3})|(?:[0-9]{9,15}))([0-9]{4})))', 'g');
    }
    concealCreditCard(input, regexpNotCreditCardCmd = this.regexpNotCCCmd, isSupportedCCFunc = this.isSupportedCCDefaultFunc.bind(this)) {
        let output = input;
        if (regexpNotCreditCardCmd && input.match(regexpNotCreditCardCmd)) {
            return output;
        }
        let result = this.regexpCC.exec(input);
        while (result != null) {
            if (isSupportedCCFunc(result[1])) {
                const len = output.length;
                // Replace any digit by an 'X'
                output =
                    output.substring(0, this.regexpCC.lastIndex - result[1].length) +
                        result[2].replace(/\d/g, 'X') +
                        result[3] +
                        output.substring(this.regexpCC.lastIndex, len);
                result = this.regexpCC.exec(input);
                if (result && result[0] === '') {
                    result = null;
                }
            }
            else {
                break;
            }
        }
        return output;
    }
    concealCrypticCommand(input) {
        const lines = input.split(/(\r\n\s*\d{1,3}|;)/);
        return lines
            .map((line) => {
            const blacklistRegex = isNaN(Number(line)) ? CRYPTIC_REQUEST_BLACKLIST : null;
            if ((!blacklistRegex || blacklistRegex.test(line)) && !WHITELIST_REGEX?.test(input)) {
                let concealedCreditCard = this.concealCreditCard(line, null, this.checkCrypticCCSupported.bind(this));
                if (concealedCreditCard !== line) {
                    concealedCreditCard = this.creditCardSecurityCodeMask(concealedCreditCard);
                }
                return concealedCreditCard;
            }
            else {
                return line;
            }
        })
            .reduce((acc, line) => acc + line, '');
    }
    /**
     *
     * HiperCard validator
     */
    isHiperCard(cardNumber) {
        let result = false;
        const cardNumberNoWhiteCharacters = cardNumber.replace(/[- ]/g, '');
        result = this.hiperCardRegExp.test(cardNumberNoWhiteCharacters);
        return result;
    }
    /**
     * Credit Card Concealment - Luhn Algorythm :
     */
    isCreditCard(input) {
        const stemp = input.replace(/[- ]/g, '');
        const len = stemp.length - 1;
        let j = 0;
        let digit;
        let sum = 0;
        for (let i = len; i > -1; i--) {
            digit = parseInt(stemp[i], 10);
            if (j % 2 === 1) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            j++;
            sum += digit;
        }
        return len > 0 && sum % 10 === 0;
    }
    /**
     * Verifies if a value corresponds to one of the supported credit card patterns supported.
     * In that case, verifies if the numbers are matching the Luhn checksum.
     *
     * @param {string} value
     * @returns true if the value corresponds to one of the supported credit card.
     */
    checkCrypticCCSupported(creditCardNumber) {
        // remove all non digit characters
        const digitValue = creditCardNumber.replace(/\D/g, '');
        // loop through the accepted cards (visa, mastercard, amex, etc.)
        return Object.entries(ACCEPTED_CREDIT_CARDS).some(([cardName, cardRegex]) => cardRegex.test(digitValue) && (this.isCreditCard(digitValue) || cardName === 'hiperCar'));
    }
    creditCardSecurityCodeMask(input) {
        let output = input;
        if (output) {
            const result = REGEX_CVV.exec(output);
            if (result?.indices) {
                output =
                    output.substring(0, result.indices[0][0]) +
                        output.substring(result.indices[0][0], result.indices[0][1]).replace(/\d/g, 'X');
            }
        }
        return output;
    }
    isSupportedCCDefaultFunc(creditCardNumber) {
        return this.isCreditCard(creditCardNumber) || this.isHiperCard(creditCardNumber);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CreditCardConcealmentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CreditCardConcealmentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CreditCardConcealmentService, decorators: [{
            type: Injectable
        }] });

/**
 * User preferences service
 * Initialization to be done at app level
 */
class UserPreferencesService {
    constructor() {
        this.userPreferences = {
            userAlias: '',
            officeList: [],
            currentOffice: '',
            loginOffice: ''
        };
    }
    /** Get user alias */
    get userAlias() {
        return this.userPreferences.userAlias;
    }
    /** Get list of valid offices for user */
    get officeList() {
        return this.userPreferences.officeList;
    }
    /** Get currently active office */
    get currentOffice() {
        return this.userPreferences.currentOffice;
    }
    /** Get logged in office */
    get loginOffice() {
        return this.userPreferences.loginOffice;
    }
    init(userPrefs) {
        this.userPreferences = userPrefs;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserPreferencesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserPreferencesService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserPreferencesService, decorators: [{
            type: Injectable
        }] });

let nextId = 0;
class MessageComponent {
    // Services are kept optional as these are only intended for SECO
    constructor(ashService, analytics, store) {
        this.ashService = ashService;
        this.analytics = analytics;
        this.store = store;
        this.dismissible = false;
        this.pageAlert = false;
        this.suffixTag = '';
        this.removeMarginBottom = false;
        this.collapsedByDefault = false;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this.closed = false;
        this.isCollapsed = false;
        this.origin = 'errorInfo';
        this.errorLinkDelimiter = '  |  ';
        this.collapseIdSuffix = nextId++;
        this.collapsibleMessages = [];
        this._messages = [];
    }
    get messages() {
        return this._messages;
    }
    set messages(messages) {
        if (messages) {
            [this.collapsibleMessages, messages] = this.separateMainAndCollapsibleMessages(messages);
        }
        this._messages = messages || [];
    }
    ngOnInit() {
        this.isCollapsed = this.collapsedByDefault;
    }
    onClose() {
        this.closed = true;
        this.close.emit();
    }
    isAshLinkActivated() {
        return this.ashService.isAshLinkActivated;
    }
    showAshLink(message) {
        return !!message.ashId && this.isAshLinkActivated();
    }
    openContentViewer(message) {
        const IFRAME = 'iframe/';
        const LANGUAGE = '/en_US';
        if (this.ashService) {
            this.ashService.sendContentViewerData(this.ashService.getAshApiUrl().concat(`${IFRAME}${message.ashId}${LANGUAGE}`), message.message, this.ashService.getAshApiUrl().concat(`${message.ashId}`), this.origin, message.code);
        }
        if (this.analytics) {
            this.analytics.track({
                action: 'error.ASHLink.click',
                action_value: JSON.stringify({
                    errorMessage: message.message,
                    errorCode: message.code
                })
            });
        }
    }
    handleMessageLinkClick(target) {
        this.store.dispatch(new Navigate(target));
    }
    separateMainAndCollapsibleMessages(messages) {
        return messages.reduce(([collapsibleErrors, mainErrors], error) => error.collapsible ? [[...collapsibleErrors, error], mainErrors] : [collapsibleErrors, [...mainErrors, error]], [[], []]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessageComponent, deps: [{ token: AshService, optional: true }, { token: AnalyticsService, optional: true }, { token: i3.Store, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: MessageComponent, selector: "ama-message", inputs: { type: "type", dismissible: "dismissible", card: "card", pageAlert: "pageAlert", suffixTag: "suffixTag", removeMarginBottom: "removeMarginBottom", collapsedByDefault: "collapsedByDefault", messages: "messages" }, outputs: { close: "close" }, ngImport: i0, template: "<ngb-alert\n  dfInsertAlertIcon\n  [type]=\"type\"\n  *ngIf=\"!closed && messages.length > 0\"\n  (closed)=\"onClose()\"\n  [dismissible]=\"dismissible\"\n  [class.df-card-alert]=\"card !== null && card !== undefined && card !== ''\"\n  [class.df-page-alert]=\"pageAlert\"\n  [class.mb-0]=\"removeMarginBottom\"\n>\n  <!-- main errors -->\n  <div class=\"df-alert-collapse-main-text\">\n    <div class=\"main-messages\">\n      <ng-template *ngTemplateOutlet=\"messageBody; context: { messages: messages }\"></ng-template>\n    </div>\n    <!-- collapse button - change provider to collapsible message to make it generic -->\n    <a\n      *ngIf=\"collapsibleMessages.length > 0\"\n      class=\"df-collapse df-alert-collapse-icon align-self-baseline\"\n      (click)=\"isCollapsed = !isCollapsed\"\n      href=\"javascript:void(0)\"\n      [attr.aria-expanded]=\"!isCollapsed\"\n      [attr.aria-controls]=\"'alert-collapse-messages-' + collapseIdSuffix\"\n    >\n      <span *ngIf=\"isCollapsed\" i18n=\"@@core.messages-section.message.alert.collapse.buttontext.ShowMore\"\n        >Show more</span\n      >\n      <span *ngIf=\"!isCollapsed\" i18n=\"@@core.messages-section.message.alert.collapse.buttontext.ShowLess\"\n        >Show less</span\n      >\n      &nbsp;\n      <span [class.fa-angle-down]=\"isCollapsed\" [class.fa-angle-up]=\"!isCollapsed\"></span>\n    </a>\n  </div>\n  <!-- collapsible errors -->\n  <div\n    *ngIf=\"collapsibleMessages.length > 0\"\n    [ngbCollapse]=\"isCollapsed\"\n    [id]=\"'alert-collapse-messages-' + collapseIdSuffix\"\n    class=\"df-alert-collapsed-text\"\n  >\n    <ng-template *ngTemplateOutlet=\"messageBody; context: { messages: collapsibleMessages }\"></ng-template>\n  </div>\n</ngb-alert>\n\n<ng-template #messageBody let-messages=\"messages\">\n  <div *ngFor=\"let message of messages\">\n    <span class=\"alert-messages-{{ type }}-message\">\n      <span *ngIf=\"message.collapsible && suffixTag\" class=\"fw-bold me-1\">{{ suffixTag }}</span>\n      <span *ngIf=\"message.message\" [innerHTML]=\"message.message | removeHtmlAttributes: message.removeHtml\"></span>\n      <span *ngIf=\"message.code\"> ({{ message.code }})</span>\n      <ng-container *ngIf=\"message.ashId && this.isAshLinkActivated()\">\n        <span>{{ errorLinkDelimiter }}</span>\n        <p class=\"d-inline\">\n          <a\n            [id]=\"'error_' + message.ashId\"\n            (click)=\"openContentViewer(message)\"\n            href=\"javascript:void(0)\"\n            i18n=\"@@core.messages-section.message.error.ashLinkText\"\n            >More on this topic</a\n          ></p\n        >\n      </ng-container>\n      <ng-container *ngIf=\"message.additionalInformation\">\n        <p class=\"d-inline\"\n          ><a href=\"javascript:void(0)\" (click)=\"handleMessageLinkClick(card)\">\n            {{ message.additionalInformation.buttonText }}</a\n          ></p\n        >\n        {{ message.additionalInformation.additionalText }}\n      </ng-container>\n    </span>\n    <ul *ngIf=\"message.subMessages && message.subMessages.length\" class=\"m-0\">\n      <li *ngFor=\"let subMessage of message.subMessages\" class=\"alert-messages-{{ type }}-submessage\">\n        <span\n          *ngIf=\"subMessage.message\"\n          [innerHTML]=\"subMessage.message | removeHtmlAttributes: message.removeHtml\"\n        ></span>\n        <span *ngIf=\"subMessage.code\"> ({{ subMessage.code }})</span>\n        <ng-container *ngIf=\"subMessage.ashId && this.isAshLinkActivated()\">\n          <span>{{ errorLinkDelimiter }}</span>\n          <p class=\"d-inline\">\n            <a\n              [id]=\"'subError_' + subMessage.ashId\"\n              (click)=\"openContentViewer(subMessage)\"\n              href=\"javascript:void(0)\"\n              i18n=\"@@core.messages-section.message.error.ashLinkText\"\n              >More on this topic</a\n            ></p\n          >\n        </ng-container>\n        <ng-container *ngIf=\"subMessage.additionalInformation\">\n          <p class=\"d-inline\"\n            ><a href=\"javascript:void(0)\" (click)=\"handleMessageLinkClick(card)\">\n              {{ subMessage.additionalInformation.buttonText }}</a\n            ></p\n          >\n          {{ subMessage.additionalInformation.additionalText }}\n        </ng-container>\n      </li>\n    </ul>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1.NgbAlert, selector: "ngb-alert", inputs: ["animation", "dismissible", "type"], outputs: ["closed"], exportAs: ["ngbAlert"] }, { kind: "directive", type: i1$4.DfInsertIconDirective, selector: "ngb-alert[dfInsertAlertIcon],ngb-toast[dfInsertToastIcon]" }, { kind: "directive", type: i1.NgbCollapse, selector: "[ngbCollapse]", inputs: ["animation", "ngbCollapse", "horizontal"], outputs: ["ngbCollapseChange", "shown", "hidden"], exportAs: ["ngbCollapse"] }, { kind: "pipe", type: RemoveHtmlAttributesPipe, name: "removeHtmlAttributes" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-message', template: "<ngb-alert\n  dfInsertAlertIcon\n  [type]=\"type\"\n  *ngIf=\"!closed && messages.length > 0\"\n  (closed)=\"onClose()\"\n  [dismissible]=\"dismissible\"\n  [class.df-card-alert]=\"card !== null && card !== undefined && card !== ''\"\n  [class.df-page-alert]=\"pageAlert\"\n  [class.mb-0]=\"removeMarginBottom\"\n>\n  <!-- main errors -->\n  <div class=\"df-alert-collapse-main-text\">\n    <div class=\"main-messages\">\n      <ng-template *ngTemplateOutlet=\"messageBody; context: { messages: messages }\"></ng-template>\n    </div>\n    <!-- collapse button - change provider to collapsible message to make it generic -->\n    <a\n      *ngIf=\"collapsibleMessages.length > 0\"\n      class=\"df-collapse df-alert-collapse-icon align-self-baseline\"\n      (click)=\"isCollapsed = !isCollapsed\"\n      href=\"javascript:void(0)\"\n      [attr.aria-expanded]=\"!isCollapsed\"\n      [attr.aria-controls]=\"'alert-collapse-messages-' + collapseIdSuffix\"\n    >\n      <span *ngIf=\"isCollapsed\" i18n=\"@@core.messages-section.message.alert.collapse.buttontext.ShowMore\"\n        >Show more</span\n      >\n      <span *ngIf=\"!isCollapsed\" i18n=\"@@core.messages-section.message.alert.collapse.buttontext.ShowLess\"\n        >Show less</span\n      >\n      &nbsp;\n      <span [class.fa-angle-down]=\"isCollapsed\" [class.fa-angle-up]=\"!isCollapsed\"></span>\n    </a>\n  </div>\n  <!-- collapsible errors -->\n  <div\n    *ngIf=\"collapsibleMessages.length > 0\"\n    [ngbCollapse]=\"isCollapsed\"\n    [id]=\"'alert-collapse-messages-' + collapseIdSuffix\"\n    class=\"df-alert-collapsed-text\"\n  >\n    <ng-template *ngTemplateOutlet=\"messageBody; context: { messages: collapsibleMessages }\"></ng-template>\n  </div>\n</ngb-alert>\n\n<ng-template #messageBody let-messages=\"messages\">\n  <div *ngFor=\"let message of messages\">\n    <span class=\"alert-messages-{{ type }}-message\">\n      <span *ngIf=\"message.collapsible && suffixTag\" class=\"fw-bold me-1\">{{ suffixTag }}</span>\n      <span *ngIf=\"message.message\" [innerHTML]=\"message.message | removeHtmlAttributes: message.removeHtml\"></span>\n      <span *ngIf=\"message.code\"> ({{ message.code }})</span>\n      <ng-container *ngIf=\"message.ashId && this.isAshLinkActivated()\">\n        <span>{{ errorLinkDelimiter }}</span>\n        <p class=\"d-inline\">\n          <a\n            [id]=\"'error_' + message.ashId\"\n            (click)=\"openContentViewer(message)\"\n            href=\"javascript:void(0)\"\n            i18n=\"@@core.messages-section.message.error.ashLinkText\"\n            >More on this topic</a\n          ></p\n        >\n      </ng-container>\n      <ng-container *ngIf=\"message.additionalInformation\">\n        <p class=\"d-inline\"\n          ><a href=\"javascript:void(0)\" (click)=\"handleMessageLinkClick(card)\">\n            {{ message.additionalInformation.buttonText }}</a\n          ></p\n        >\n        {{ message.additionalInformation.additionalText }}\n      </ng-container>\n    </span>\n    <ul *ngIf=\"message.subMessages && message.subMessages.length\" class=\"m-0\">\n      <li *ngFor=\"let subMessage of message.subMessages\" class=\"alert-messages-{{ type }}-submessage\">\n        <span\n          *ngIf=\"subMessage.message\"\n          [innerHTML]=\"subMessage.message | removeHtmlAttributes: message.removeHtml\"\n        ></span>\n        <span *ngIf=\"subMessage.code\"> ({{ subMessage.code }})</span>\n        <ng-container *ngIf=\"subMessage.ashId && this.isAshLinkActivated()\">\n          <span>{{ errorLinkDelimiter }}</span>\n          <p class=\"d-inline\">\n            <a\n              [id]=\"'subError_' + subMessage.ashId\"\n              (click)=\"openContentViewer(subMessage)\"\n              href=\"javascript:void(0)\"\n              i18n=\"@@core.messages-section.message.error.ashLinkText\"\n              >More on this topic</a\n            ></p\n          >\n        </ng-container>\n        <ng-container *ngIf=\"subMessage.additionalInformation\">\n          <p class=\"d-inline\"\n            ><a href=\"javascript:void(0)\" (click)=\"handleMessageLinkClick(card)\">\n              {{ subMessage.additionalInformation.buttonText }}</a\n            ></p\n          >\n          {{ subMessage.additionalInformation.additionalText }}\n        </ng-container>\n      </li>\n    </ul>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: AshService, decorators: [{
                    type: Optional
                }] }, { type: AnalyticsService, decorators: [{
                    type: Optional
                }] }, { type: i3.Store, decorators: [{
                    type: Optional
                }] }], propDecorators: { type: [{
                type: Input
            }], dismissible: [{
                type: Input
            }], card: [{
                type: Input
            }], pageAlert: [{
                type: Input
            }], suffixTag: [{
                type: Input
            }], removeMarginBottom: [{
                type: Input
            }], collapsedByDefault: [{
                type: Input
            }], close: [{
                type: Output
            }], messages: [{
                type: Input
            }] } });

class MessagesSectionService {
    getBootstrapAlertType(messageType) {
        if (messageType && Object.values(BootstrapAlertType).some((alertType) => alertType === messageType)) {
            return messageType;
        }
        if (messageType === MessageType.ERROR ||
            messageType === MessageType.CRITICAL ||
            messageType === MessageType.FATAL) {
            return BootstrapAlertType.DANGER;
        }
        else if (messageType === MessageType.WARNING) {
            return BootstrapAlertType.WARNING;
        }
        else if (messageType === MessageType.SUCCESS) {
            return BootstrapAlertType.SUCCESS;
        }
        return BootstrapAlertType.INFO;
    }
    getMessages(messageBean) {
        return messageBean?.map((msgBean) => this.mapAlertMessageToMessage(msgBean)) || [];
    }
    mapAlertMessageToMessage(messageBean) {
        return {
            code: messageBean.code ? Number.parseInt(messageBean.code, 10) : undefined,
            type: messageBean.type || MessageType.ERROR,
            message: messageBean.localizedMessage,
            subMessages: this.getMessages(messageBean.subMessages || []),
            collapsible: messageBean.collapsible,
            removeHtml: false
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class MessagesSectionComponent {
    // Services are kept optional as these are only intended for SECO
    constructor(messagesSectionService, ashService, analytics) {
        this.messagesSectionService = messagesSectionService;
        this.ashService = ashService;
        this.analytics = analytics;
        this.dismissible = false;
        this.pageAlert = false;
        this.suffixTag = '';
        this.collapsedByDefault = false;
        this.closeMessageGroup = new EventEmitter();
        this.removeMarginBottom = input(false);
        this._groupedMessages = new GroupedMessages();
    }
    get groupedMessages() {
        return this._groupedMessages;
    }
    set messages(messages) {
        this._groupedMessages = new GroupedMessages();
        if (messages && messages.length > 0) {
            messages.forEach((message) => {
                if (this.ashService) {
                    this.setAshId(message);
                }
                this._groupedMessages[this.messagesSectionService.getBootstrapAlertType(message.type)].push(message);
            });
        }
    }
    onCloseMessageGroup(messages) {
        this.closeMessageGroup.emit(messages);
    }
    /*
     * Sets the ASH article id for the error message, if exists
     */
    setAshId(message) {
        if (message.type === 'E' && message.code && this.ashService) {
            message.ashId = this.ashService.getAshId(message.code.toString());
            this.analytics?.track({
                action: 'error.ASHLink.display',
                action_value: JSON.stringify({
                    errorMessage: message.message,
                    errorCode: message.code,
                    ashArticleId: message.ashId
                })
            });
            message.subMessages?.forEach((subMessage) => {
                this.setAshId(subMessage);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionComponent, deps: [{ token: MessagesSectionService }, { token: AshService, optional: true }, { token: AnalyticsService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.12", type: MessagesSectionComponent, selector: "ama-messages-section", inputs: { dismissible: { classPropertyName: "dismissible", publicName: "dismissible", isSignal: false, isRequired: false, transformFunction: null }, card: { classPropertyName: "card", publicName: "card", isSignal: false, isRequired: false, transformFunction: null }, pageAlert: { classPropertyName: "pageAlert", publicName: "pageAlert", isSignal: false, isRequired: false, transformFunction: null }, suffixTag: { classPropertyName: "suffixTag", publicName: "suffixTag", isSignal: false, isRequired: false, transformFunction: null }, collapsedByDefault: { classPropertyName: "collapsedByDefault", publicName: "collapsedByDefault", isSignal: false, isRequired: false, transformFunction: null }, removeMarginBottom: { classPropertyName: "removeMarginBottom", publicName: "removeMarginBottom", isSignal: true, isRequired: false, transformFunction: null }, messages: { classPropertyName: "messages", publicName: "messages", isSignal: false, isRequired: false, transformFunction: null } }, outputs: { closeMessageGroup: "closeMessageGroup" }, ngImport: i0, template: "<div *ngIf=\"groupedMessages\" class=\"alert-messages\">\n  <ng-container *ngFor=\"let item of groupedMessages | keyvalue\">\n    <ama-message\n      *ngIf=\"item.value?.length\"\n      [messages]=\"item.value\"\n      [type]=\"item.key\"\n      [dismissible]=\"dismissible\"\n      [card]=\"card\"\n      [pageAlert]=\"pageAlert\"\n      (close)=\"onCloseMessageGroup(item.value)\"\n      class=\"alert-message-{{ item.key }}\"\n      [suffixTag]=\"suffixTag\"\n      [collapsedByDefault]=\"collapsedByDefault\"\n      [removeMarginBottom]=\"removeMarginBottom()\"\n    >\n    </ama-message>\n  </ng-container>\n</div>\n", dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MessageComponent, selector: "ama-message", inputs: ["type", "dismissible", "card", "pageAlert", "suffixTag", "removeMarginBottom", "collapsedByDefault", "messages"], outputs: ["close"] }, { kind: "pipe", type: i4.KeyValuePipe, name: "keyvalue" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-messages-section', template: "<div *ngIf=\"groupedMessages\" class=\"alert-messages\">\n  <ng-container *ngFor=\"let item of groupedMessages | keyvalue\">\n    <ama-message\n      *ngIf=\"item.value?.length\"\n      [messages]=\"item.value\"\n      [type]=\"item.key\"\n      [dismissible]=\"dismissible\"\n      [card]=\"card\"\n      [pageAlert]=\"pageAlert\"\n      (close)=\"onCloseMessageGroup(item.value)\"\n      class=\"alert-message-{{ item.key }}\"\n      [suffixTag]=\"suffixTag\"\n      [collapsedByDefault]=\"collapsedByDefault\"\n      [removeMarginBottom]=\"removeMarginBottom()\"\n    >\n    </ama-message>\n  </ng-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: MessagesSectionService }, { type: AshService, decorators: [{
                    type: Optional
                }] }, { type: AnalyticsService, decorators: [{
                    type: Optional
                }] }], propDecorators: { dismissible: [{
                type: Input
            }], card: [{
                type: Input
            }], pageAlert: [{
                type: Input
            }], suffixTag: [{
                type: Input
            }], collapsedByDefault: [{
                type: Input
            }], closeMessageGroup: [{
                type: Output
            }], messages: [{
                type: Input
            }] } });

class MessagesSectionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionModule, declarations: [MessagesSectionComponent, MessageComponent], imports: [CommonModule, DfAlertModule, CorePipesModule, NgbCollapseModule], exports: [MessagesSectionComponent, MessageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionModule, imports: [CommonModule, DfAlertModule, CorePipesModule, NgbCollapseModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MessagesSectionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MessagesSectionComponent, MessageComponent],
                    imports: [CommonModule, DfAlertModule, CorePipesModule, NgbCollapseModule],
                    exports: [MessagesSectionComponent, MessageComponent]
                }]
        }] });

const messageBeansMock = [
    {
        code: '1234',
        fieldRef: '',
        fieldRefs: [],
        localizedMessage: 'I am an error message used for testing.',
        subMessages: [],
        type: 'E',
        collapsible: false
    },
    {
        code: '2341',
        fieldRef: '',
        fieldRefs: [],
        localizedMessage: 'I am an information message used for testing.',
        subMessages: [],
        type: 'I'
    },
    {
        code: '3412',
        fieldRef: '',
        fieldRefs: [],
        localizedMessage: 'I am a warning message used for testing.',
        subMessages: [
            {
                code: '2399',
                fieldRef: '',
                fieldRefs: [],
                localizedMessage: 'I am a warning sub-message used for testing.',
                subMessages: [],
                type: 'W'
            }
        ],
        type: 'W'
    },
    {
        code: '4123',
        fieldRef: '',
        fieldRefs: [],
        localizedMessage: 'I am a success message used for testing.',
        subMessages: [],
        type: 'O'
    }
];

class AlertManagerService {
    // Services are kept optional as these are only intended for SECO
    constructor(ashService, analytics) {
        this.ashService = ashService;
        this.analytics = analytics;
    }
    /**
     * Appends ASH article id to the alert messages
     * @param messages
     * @returns messages with ASH article id
     */
    appendAshIds(messages) {
        return messages.map((message) => ({
            ...message,
            ashId: this.getAshId(message.code, message.message),
            ...(!!message.subMessages && { subMessages: this.appendAshIds(message.subMessages) })
        }));
    }
    /**
     * Gets the ASH article id corresponding to the error code/number, if exists
     * @param errorCode error code/number
     * @param errorMessage error localized message
     * @returns ASH article id
     */
    getAshId(errorCode, errorMessage) {
        let ashId;
        if (this.ashService && errorCode) {
            ashId = this.ashService.getAshId(errorCode.toString());
        }
        if (this.analytics && ashId) {
            this.analytics.track({
                action: 'error.ASHLink.display',
                action_value: JSON.stringify({ errorMessage, errorCode, ashArticleId: ashId })
            });
        }
        return ashId;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerService, deps: [{ token: AshService, optional: true }, { token: AnalyticsService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AshService, decorators: [{
                    type: Optional
                }] }, { type: AnalyticsService, decorators: [{
                    type: Optional
                }] }] });

const setAlertsData = createAction('[AlertManager] Set alerts data', props());
const setMessages = createAction('[AlertManager] Set global alert messages', props());
const setMessagesForCard = createAction('[AlertManager] Set alert messages for card', props());

class AlertManagerUtils {
    /**
     * Processes the alert data into structured messages
     * @param data alert messages
     * @returns messages
     */
    static processData(data) {
        const newAlertMessages = [];
        if (data && data.length !== 0) {
            data.forEach((alertMessage) => {
                newAlertMessages.push(this.mapAlertMessageToMessage(alertMessage));
            });
        }
        return newAlertMessages;
    }
    static mapAlertMessageToMessage(alertMessage) {
        const alertCode = alertMessage.code || alertMessage.number;
        const message = {
            code: alertCode ? Number.parseInt(alertCode, 10) : undefined,
            type: alertMessage.type,
            message: alertMessage.localizedMessage,
            removeHtml: false,
            collapsible: alertMessage.collapsible,
            suffixTag: alertMessage.suffixTag
        };
        if (alertMessage.buttonMessage && alertMessage.additionalInformation) {
            const additionalInformation = {
                buttonText: alertMessage.buttonMessage,
                additionalText: alertMessage.additionalInformation
            };
            message.additionalInformation = additionalInformation;
        }
        const subMessages = this.mapAlertMessagesToMessages(alertMessage.subMessages);
        if (!subMessages) {
            return message;
        }
        return {
            ...message,
            subMessages
        };
    }
    static mapAlertMessagesToMessages(alertMessages) {
        if (alertMessages) {
            return alertMessages.map((alertMessage) => this.mapAlertMessageToMessage(alertMessage));
        }
        else {
            return undefined;
        }
    }
}

const ALERT_MANAGER_FEATURE = 'alertManagerReducer';
const initialState = {
    messages: [],
    messagesByCard: {},
    persistentMessages: []
};
const alertManagerReducer = createReducer(initialState, on(setAlertsData, (state, { data, card, persistAfterRefresh }) => {
    const messages = AlertManagerUtils.processData(data);
    if (card) {
        return {
            ...state,
            messagesByCard: { ...state.messagesByCard, [card]: messages }
        };
    }
    else {
        // concat new messages and the persistent ones
        const allMessages = [...state.persistentMessages, ...messages];
        // define new persistent messages
        const persistentMessages = persistAfterRefresh ? messages : [];
        return { ...state, messages: allMessages, persistentMessages };
    }
}), on(setMessages, (state, { messages }) => ({ ...state, messages })), on(setMessagesForCard, (state, { cardId, messages }) => ({
    ...state,
    messagesByCard: { ...state.messagesByCard, [cardId]: messages }
})));
const selectState = createFeatureSelector(ALERT_MANAGER_FEATURE);
const selectMessages = (cardId) => createSelector(selectState, (state) => (cardId ? state.messagesByCard[cardId] : state.messages));

class AlertManagerComponent {
    constructor(config) {
        this.config = config;
        this.errors = [];
        this.errorType = BootstrapAlertType.DANGER;
        this.messagesSectionService = inject(MessagesSectionService);
        this.alertManagerService = inject(AlertManagerService);
        this.store = inject(Store);
        if (this.config) {
            this.store.dispatch(setAlertsData(this.config));
        }
    }
    get currentCard() {
        return this.config?.card;
    }
    get messages$() {
        return this.store.select(selectMessages(this.currentCard)).pipe(map$1((messages) => this.alertManagerService.appendAshIds(messages)), tap((messages) => {
            this.errors = messages.filter((message) => message.type === MessageType.ERROR);
        }));
    }
    get suffixMessage() {
        return this.errors.find((message) => message.suffixTag)?.suffixTag || '';
    }
    getMessageType(type) {
        return this.messagesSectionService.getBootstrapAlertType(type);
    }
    removeMarginBottom(message) {
        return !!message.additionalInformation;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerComponent, deps: [{ token: CONFIG_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: AlertManagerComponent, isStandalone: true, selector: "ama-alert-manager", providers: [AlertManagerService], ngImport: i0, template: "@for (message of messages$ | async; track message) {\n  @if ( getMessageType(message.type) !== errorType) {\n    <ng-container\n      *ngTemplateOutlet=\"\n        messageTemplate;\n        context: { message: [message], type:  getMessageType(message.type) }\n      \"\n    ></ng-container>\n  }\n}\n@if (errors.length > 0) {\n  <ng-container *ngTemplateOutlet=\"messageTemplate; context: { message: errors, type: errorType }\"></ng-container>\n}\n<ng-template #messageTemplate let-message=\"message\" let-type=\"type\">\n  <ama-message\n    [messages]=\"message\"\n    [type]=\"type\"\n    [dismissible]=\"false\"\n    [card]=\"currentCard || ''\"\n    [removeMarginBottom]=\"removeMarginBottom(message)\"\n    [suffixTag]=\"suffixMessage\"\n  >\n  </ama-message>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "ngmodule", type: DfAlertModule }, { kind: "ngmodule", type: MessagesSectionModule }, { kind: "component", type: MessageComponent, selector: "ama-message", inputs: ["type", "dismissible", "card", "pageAlert", "suffixTag", "removeMarginBottom", "collapsedByDefault", "messages"], outputs: ["close"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-alert-manager', standalone: true, imports: [CommonModule, DfAlertModule, MessagesSectionModule], providers: [AlertManagerService], changeDetection: ChangeDetectionStrategy.OnPush, template: "@for (message of messages$ | async; track message) {\n  @if ( getMessageType(message.type) !== errorType) {\n    <ng-container\n      *ngTemplateOutlet=\"\n        messageTemplate;\n        context: { message: [message], type:  getMessageType(message.type) }\n      \"\n    ></ng-container>\n  }\n}\n@if (errors.length > 0) {\n  <ng-container *ngTemplateOutlet=\"messageTemplate; context: { message: errors, type: errorType }\"></ng-container>\n}\n<ng-template #messageTemplate let-message=\"message\" let-type=\"type\">\n  <ama-message\n    [messages]=\"message\"\n    [type]=\"type\"\n    [dismissible]=\"false\"\n    [card]=\"currentCard || ''\"\n    [removeMarginBottom]=\"removeMarginBottom(message)\"\n    [suffixTag]=\"suffixMessage\"\n  >\n  </ama-message>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CONFIG_TOKEN]
                }] }] });

class AlertManagerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerModule, imports: [AlertManagerComponent, i3.StoreFeatureModule], exports: [AlertManagerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerModule, imports: [AlertManagerComponent, StoreModule.forFeature(ALERT_MANAGER_FEATURE, alertManagerReducer)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AlertManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [AlertManagerComponent, StoreModule.forFeature(ALERT_MANAGER_FEATURE, alertManagerReducer)],
                    exports: [AlertManagerComponent]
                }]
        }] });

class GlobalListsCacheUtil {
    constructor() {
        // empty on purpose
    }
    /**
     * Get all global list names not cached yet
     *
     * @param allGlobalListNames All global list names
     * @param globalListCache The global list cache
     * @returns All global list names not cached yet
     *
     * @private
     */
    static getGlobalListNamesNotCached(allGlobalListNames, globalListCache) {
        return allGlobalListNames.filter((key) => !globalListCache.hasOwnProperty(key));
    }
    /**
     * Get the specified global lists from cache
     *
     * @param globalListNames The wanted global list names
     * @param globalListCached The global list cached
     * @returns The global list from cache
     *
     * @private
     */
    static getGlobalListsFromCache(globalListNames, globalListCached) {
        return globalListNames.reduce((acc, key) => {
            if (globalListCached.hasOwnProperty(key)) {
                acc[key] = globalListCached[key];
            }
            return acc;
        }, {});
    }
}

class UrlParametersUtil {
    constructor() {
        // empty on purpose
    }
    /**
     * Helper function for getting typical URL parameters query string
     * @param config HttpConfig
     * @param {{ addEjParameter?: boolean; addRecordActions?: boolean; chainedParameters?: boolean }} [{
     *     chainedParameters = true, - chain with ampersand as first returned character (default) or question mark
     *     addRecordActions = false, - add recordActions parameter
     *     addEjParameter = true - add e=j parameter
     *   }={}]
     * @returns string of parameters to appended to URL
     */
    static getURLParameters(config, { chainedParameters = true, addRecordActions = false, addEjParameter = true } = {}) {
        const ej = addEjParameter ? '&e=j' : '';
        let parameters = `&SITE=${config.siteCode}&LANGUAGE=${config.language}${ej}`;
        if (addRecordActions) {
            parameters += '&recordActions=true';
        }
        if (config.environment) {
            parameters += `&OCTX=${config.environment}`;
        }
        if (config.additionalParameters) {
            parameters += UrlParametersUtil.convertObjectToQueryString(config.additionalParameters);
        }
        if (config.addUrlOverrides) {
            parameters += UrlParametersUtil.getWindowLocationOvParams();
        }
        if (parameters) {
            // for chained URL parameters, ensure that first separator is question mark
            const firstCharacter = chainedParameters ? '&' : '?';
            parameters = firstCharacter + parameters.substring(1);
        }
        return parameters;
    }
    /**
     * Helper that converts a URL query parameters to a string
     * with preceding ampersand.
     * @private
     */
    static convertObjectToQueryString(parameterObject) {
        return Object.entries(parameterObject)
            .map((param) => `&${param[0]}=${param[1]}`)
            .join('');
    }
    /**
     * Getting the window location overridden parameters
     * @private
     */
    static getWindowLocationOvParams() {
        const search = UrlParametersUtil.getWindowLocationSearch().split('?')?.[1] || '';
        return search
            .split('&')
            .reduce((acc, cur) => {
            if (cur.startsWith('OV_')) {
                acc.push(`&${cur}`);
            }
            return acc;
        }, [])
            .join('');
    }
    /**
     * Getting the window location search
     * @private
     */
    static getWindowLocationSearch() {
        return window.location.search;
    }
}

const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
const httpOptions = { headers, withCredentials: true };
class HttpServiceImpl extends HttpService {
    constructor(http, config, httpConfig, queue) {
        super();
        this.http = http;
        this.config = config;
        this.httpConfig = httpConfig;
        this.queue = queue;
        this.configurationList = {};
        this.globalListsCached = {};
        if (config) {
            this.httpConfig.initConfig(config);
        }
    }
    postDac(actionName, data = {}) {
        return this.queue
            .addRequest(this.http.post(this.constructDacURL(actionName), this.constructData(data), httpOptions))
            .pipe(map$1(parseDacResponse));
    }
    postApfPlus(apfModule, action, data, handler, webapp) {
        const body = handler ? handler.prepareRequest(data) : this.constructData(data);
        return this.queue
            .addRequest(this.http.post(this.constructApfPlusURL(apfModule, action, webapp), body, {
            headers,
            withCredentials: true,
            observe: 'response',
            responseType: 'text'
        }))
            .pipe(map$1((res) => (handler ? handler.processResponse(res.body) : this.apfExtractData(res))));
    }
    getApfResources(apfModules) {
        const config = this.httpConfig.getConfig() || {};
        const urlParameters = UrlParametersUtil.getURLParameters(config);
        const url = `/app_sell2.0${constructApfPlusResourcesURL(apfModules, config.jSessionId)}${urlParameters}`;
        return this.http
            .get(url, { headers, withCredentials: true, observe: 'response', responseType: 'text' })
            .pipe(map$1(apfExtractResourceData.bind(this)));
    }
    loadGlobalLists(listNames) {
        if (!listNames?.length) {
            return of({});
        }
        const globalListNamesNotCached = GlobalListsCacheUtil.getGlobalListNamesNotCached(listNames, this.globalListsCached);
        if (globalListNamesNotCached.length === 0) {
            return of(GlobalListsCacheUtil.getGlobalListsFromCache(listNames, this.globalListsCached));
        }
        else {
            const config = this.httpConfig.getConfig() || {};
            const urlParameters = UrlParametersUtil.getURLParameters(config, {
                addEjParameter: false,
                addRecordActions: config.recordActions
            });
            const url = constructApfPlusGlobalsURL(globalListNamesNotCached, config.jSessionId);
            return this.http.post(`${config.baseUrl}${url}${urlParameters}`, httpOptions).pipe(tap((fetchedGlobalLists) => {
                this.globalListsCached = {
                    ...this.globalListsCached,
                    ...fetchedGlobalLists
                };
            }), map$1(() => GlobalListsCacheUtil.getGlobalListsFromCache(listNames, this.globalListsCached)));
        }
    }
    /**
     * Fetch module configuration and cache them.
     * Limitation: But if multiple call are made for same module at the same time before one of them succeeds,
     * this method triggers multiple HTTP requests for the module and caches the first response it receives.
     */
    getModuleConfiguration(moduleName) {
        if (this.configurationList[moduleName]) {
            return of(this.configurationList[moduleName]);
        }
        else {
            return this.postApfPlus('configuration', 'getConfiguration', { module: moduleName }).pipe(map$1((data) => {
                const response = data.response;
                if (!response || !response.model || !response.model.moduleParameters[moduleName]) {
                    throw Error(`getConfiguration of ${moduleName} : No configuration returned`);
                }
                const moduleData = response.model.moduleParameters[moduleName].parameters;
                this.configurationList[moduleName] = moduleData;
                return this.configurationList[moduleName];
            }));
        }
    }
    constructDacURL(action) {
        const baseWithAction = `${(this.httpConfig.getConfig() || {}).baseUrl}/dac/${action}`;
        return this.constructUrl(baseWithAction);
    }
    constructApfPlusURL(apfModule, action, webapp) {
        const baseWithAction = `${webapp || (this.httpConfig.getConfig() || {}).baseUrl}/apfplus/modules/${apfModule}/${action}`;
        return this.constructUrl(baseWithAction);
    }
    constructUrl(url) {
        const config = this.httpConfig.getConfig() || {};
        let s = url;
        if (config.jSessionId) {
            s += `;jsessionid=${config.jSessionId}`;
        }
        s += UrlParametersUtil.getURLParameters(config, {
            chainedParameters: false,
            addRecordActions: config.recordActions
        });
        if (config.recordActions) {
            s += `&recordActions=true`;
        }
        return s;
    }
    /**
     * Build the data string from the JSON input
     * data in format JSON
     * {string} Stringify of the data
     */
    constructData(data) {
        return 'data=' + encodeURIComponent(JSON.stringify(data));
    }
    apfExtractData(res) {
        let result = {};
        let frameworkResult = {};
        const body = res.body?.replace(/\n|\r\n|\r\n\t/gm, '') || '';
        const framework = body.match(/<framework>(.*)<\/framework>/);
        const ariaResponse = body.match(/<data>(.*)<\/data>/);
        if (framework && framework.length > 1) {
            let stResult = framework[1].replace(/<!\[CDATA\[/g, '').replace(/]]>/g, '');
            stResult = stResult.replace(/"\{/g, '{').replace(/\}"/g, '}').replace(/\\"/g, '"');
            frameworkResult = JSON.parse(stResult);
            if (frameworkResult.session) {
                frameworkResult = frameworkResult.session;
            }
        }
        if (ariaResponse && ariaResponse.length > 1) {
            // ariaResponse can be split between different CDATA
            const stResult = ariaResponse[1]
                .replace(/<!\[CDATA\[/g, '')
                .replace(/]]>/g, '')
                .replace(/"\{/g, "'{")
                .replace(/\}"/g, "}'");
            result = Function(`"use strict";return (${stResult})`)();
            if (result && result.model) {
                result = result.model;
            }
        }
        // we embed the JSON in a response to fake the server response as a JSON
        return {
            response: {
                model: result,
                JsessionId: frameworkResult.id
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpServiceImpl, deps: [{ token: i1$1.HttpClient }, { token: HTTP_CONFIG_TOKEN, optional: true }, { token: HttpConfigService }, { token: QueueService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpServiceImpl }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: HttpServiceImpl, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [HTTP_CONFIG_TOKEN]
                }] }, { type: HttpConfigService }, { type: QueueService }] });

class ReefAppModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('[SUITS ERROR] ReefAppModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot() {
        return {
            ngModule: ReefAppModule,
            providers: [
                QueueService,
                { provide: HttpService, useClass: HttpServiceImpl },
                { provide: Http1AXMLService, useClass: Http1AXMLServiceImpl }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefAppModule, deps: [{ token: ReefAppModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ReefAppModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefAppModule, providers: [provideHttpClient(withInterceptorsFromDi())], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefAppModule, decorators: [{
            type: NgModule,
            args: [{ imports: [CommonModule], providers: [provideHttpClient(withInterceptorsFromDi())] }]
        }], ctorParameters: () => [{ type: ReefAppModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

class BooleanComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BooleanComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: BooleanComponent, isStandalone: true, selector: "ama-form-factory-boolean-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          [prefixId]="item.itemName"
          type="checkbox"
          class="form-check-input"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
      </div>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$5.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }, { kind: "ngmodule", type: DfTooltipModule }, { kind: "directive", type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BooleanComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-boolean-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          [prefixId]="item.itemName"
          type="checkbox"
          class="form-check-input"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
      </div>
    }
  `,
                    imports: [FormsModule, ReactiveFormsModule, IdGenerationModule, DfTooltipModule]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class TitleComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: TitleComponent, isStandalone: true, selector: "ama-form-factory-title-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <h4 [prefixId]="item.itemName">
        {{ item.metadata.label }}
      </h4>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-title-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <h4 [prefixId]="item.itemName">
        {{ item.metadata.label }}
      </h4>
    }
  `,
                    imports: [IdGenerationModule]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class EnumComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: EnumComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: EnumComponent, isStandalone: true, selector: "ama-form-factory-enum-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        @if (item.metadata.optionItems && item.metadata.optionItems.length > 4) {
          <ng-select
            [labelForId]="item.itemName"
            class="form-control p-0"
            [formControlName]="item.itemName"
            [prefixId]="item.itemName"
            [ngbTooltip]="item.metadata.tooltip ?? ''"
            [selectOnTab]="true"
            [items]="item.metadata.optionItems"
            [searchable]="false"
            [clearable]="false"
            bindValue="value"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.label }}
            </ng-template>
          </ng-select>
        } @else {
          <div
            role="radiogroup"
            class="d-flex justify-content-start gap-5"
            [prefixId]="item.itemName"
            [ngbTooltip]="item.metadata.tooltip ?? ''"
          >
            @for (optionItems of item.metadata.optionItems; track optionItems.value) {
              <div class="form-check">
                <label class="form-check-label" [prefixFor]="item.itemName + optionItems.label">
                  {{ optionItems.label }}</label
                >
                <input
                  [formControlName]="item.itemName"
                  [attr.name]="item.itemName"
                  [prefixId]="item.itemName + optionItems.label"
                  class="form-check-input"
                  type="radio"
                  [value]="optionItems.value"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$5.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i1$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: NgSelectModule }, { kind: "component", type: i2.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i2.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }, { kind: "ngmodule", type: DfTooltipModule }, { kind: "directive", type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: EnumComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-enum-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        @if (item.metadata.optionItems && item.metadata.optionItems.length > 4) {
          <ng-select
            [labelForId]="item.itemName"
            class="form-control p-0"
            [formControlName]="item.itemName"
            [prefixId]="item.itemName"
            [ngbTooltip]="item.metadata.tooltip ?? ''"
            [selectOnTab]="true"
            [items]="item.metadata.optionItems"
            [searchable]="false"
            [clearable]="false"
            bindValue="value"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.label }}
            </ng-template>
          </ng-select>
        } @else {
          <div
            role="radiogroup"
            class="d-flex justify-content-start gap-5"
            [prefixId]="item.itemName"
            [ngbTooltip]="item.metadata.tooltip ?? ''"
          >
            @for (optionItems of item.metadata.optionItems; track optionItems.value) {
              <div class="form-check">
                <label class="form-check-label" [prefixFor]="item.itemName + optionItems.label">
                  {{ optionItems.label }}</label
                >
                <input
                  [formControlName]="item.itemName"
                  [attr.name]="item.itemName"
                  [prefixId]="item.itemName + optionItems.label"
                  class="form-check-input"
                  type="radio"
                  [value]="optionItems.value"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  `,
                    imports: [FormsModule, NgSelectModule, ReactiveFormsModule, IdGenerationModule, DfTooltipModule]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class NumberComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NumberComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: NumberComponent, isStandalone: true, selector: "ama-form-factory-number-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          [prefixId]="item.itemName"
          type="number"
          class="form-control"
          value="parameter.defaultValue"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
      </div>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$5.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }, { kind: "ngmodule", type: DfTooltipModule }, { kind: "directive", type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NumberComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-number-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          [prefixId]="item.itemName"
          type="number"
          class="form-control"
          value="parameter.defaultValue"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
      </div>
    }
  `,
                    imports: [FormsModule, ReactiveFormsModule, IdGenerationModule, DfTooltipModule]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class ErrorMessagePipe {
    transform(errors, validators) {
        if (errors) {
            return Object.keys(errors).map((key) => validators[key].errorMessage);
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ErrorMessagePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ErrorMessagePipe, isStandalone: true, name: "errorMessage" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ErrorMessagePipe, decorators: [{
            type: Pipe,
            args: [{
                    standalone: true,
                    name: 'errorMessage'
                }]
        }] });

class StringComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: StringComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: StringComponent, isStandalone: true, selector: "ama-form-factory-string-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          class="form-control"
          [class.is-invalid]="factoryService.form.get(item.itemName)?.invalid"
          [prefixId]="item.itemName"
          type="text"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
        @if (item.metadata.validators) {
          <span
            [ngClass]="factoryService.form.get(item.itemName)?.errors ? 'invalid-feedback' : 'form-text text-muted'"
          >
            <dl>
              @for (
                error of factoryService.form.get(item.itemName)?.errors | errorMessage: item.metadata.validators;
                track error
              ) {
                <dd>{{ error }}</dd>
              }
            </dl>
          </span>
        }
      </div>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }, { kind: "ngmodule", type: DfTooltipModule }, { kind: "directive", type: i1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: ErrorMessagePipe, name: "errorMessage" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: StringComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-string-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <div [formGroup]="factoryService.form">
        <input
          [formControlName]="item.itemName"
          class="form-control"
          [class.is-invalid]="factoryService.form.get(item.itemName)?.invalid"
          [prefixId]="item.itemName"
          type="text"
          [ngbTooltip]="item.metadata.tooltip ?? ''"
        />
        @if (item.metadata.validators) {
          <span
            [ngClass]="factoryService.form.get(item.itemName)?.errors ? 'invalid-feedback' : 'form-text text-muted'"
          >
            <dl>
              @for (
                error of factoryService.form.get(item.itemName)?.errors | errorMessage: item.metadata.validators;
                track error
              ) {
                <dd>{{ error }}</dd>
              }
            </dl>
          </span>
        }
      </div>
    }
  `,
                    imports: [FormsModule, ReactiveFormsModule, IdGenerationModule, DfTooltipModule, NgClass, ErrorMessagePipe]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class LabelComponent {
    constructor() {
        this.factoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: LabelComponent, isStandalone: true, selector: "ama-form-factory-label-item", inputs: { itemName: "itemName" }, ngImport: i0, template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <label class="form-label p-0" [prefixFor]="item.itemName">{{ item.metadata.label }}</label>
    }
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: IdGenerationModule }, { kind: "directive", type: IdGenerationDirective, selector: "[prefixId], [prefixFor], [prefixAriaControls], [prefixLabelForId], [prefixAriaLabelledby]", inputs: ["prefixId", "prefixFor", "prefixAriaControls", "prefixLabelForId", "prefixAriaLabelledby"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-label-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    @if (factoryService.getItems()[this.itemName]; as item) {
      <label class="form-label p-0" [prefixFor]="item.itemName">{{ item.metadata.label }}</label>
    }
  `,
                    imports: [IdGenerationModule]
                }]
        }], propDecorators: { itemName: [{
                type: Input
            }] } });

class FormFactoryDirective {
    constructor() {
        this.factoryService = inject(FormFactoryService);
        this.viewContainerRef = inject(ViewContainerRef);
    }
    set formFactory(formFactory) {
        if (formFactory) {
            this.viewContainerRef.clear();
            const component = this.viewContainerRef.createComponent(ITEM_TYPES[formFactory.type]);
            this.factoryService.showFormItem(formFactory);
            component.instance.itemName = formFactory.itemName;
            this.itemName = formFactory.itemName;
        }
    }
    ngOnDestroy() {
        if (this.itemName) {
            this.factoryService.hideFormItem(this.itemName);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: FormFactoryDirective, isStandalone: true, selector: "[formFactory]", inputs: { formFactory: "formFactory" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[formFactory]',
                    standalone: true
                }]
        }], propDecorators: { formFactory: [{
                type: Input
            }] } });

class ModalLayoutComponent {
    constructor() {
        this.ITEMS_WITH_LABEL = ITEMS_WITH_LABEL;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: ModalLayoutComponent, isStandalone: true, selector: "ama-form-factory-modal-layout", inputs: { item: "item" }, ngImport: i0, template: `
    <div class="form-group d-flex flex-column pb-5">
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-12">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "ama-form-factory-label-item", inputs: ["itemName"] }, { kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-modal-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    <div class="form-group d-flex flex-column pb-5">
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-12">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `,
                    imports: [LabelComponent, FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class ColumnLayoutComponent {
    constructor() {
        this.ITEMS_WITH_LABEL = ITEMS_WITH_LABEL;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ColumnLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: ColumnLayoutComponent, isStandalone: true, selector: "ama-form-factory-column-layout", inputs: { item: "item" }, ngImport: i0, template: `
    <div class="form-group d-flex flex-column align-items-start justify-content-between pb-5">
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-12 col-sm-8 col-md-6 col-lg-5">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "ama-form-factory-label-item", inputs: ["itemName"] }, { kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ColumnLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-column-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    <div class="form-group d-flex flex-column align-items-start justify-content-between pb-5">
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-12 col-sm-8 col-md-6 col-lg-5">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `,
                    imports: [LabelComponent, FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class BooleanLayoutComponent {
    constructor() {
        this.ITEMS_WITH_LABEL = ITEMS_WITH_LABEL;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BooleanLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: BooleanLayoutComponent, isStandalone: true, selector: "ama-form-factory-boolean-layout", inputs: { item: "item" }, ngImport: i0, template: `
    <div class="form-group d-flex align-items-start justify-content-start gap-3 pb-3">
      <ng-template [formFactory]="item"></ng-template>
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item [itemName]="item.itemName"></ama-form-factory-label-item>
      }
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "ama-form-factory-label-item", inputs: ["itemName"] }, { kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: BooleanLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-boolean-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    <div class="form-group d-flex align-items-start justify-content-start gap-3 pb-3">
      <ng-template [formFactory]="item"></ng-template>
      @if (ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item [itemName]="item.itemName"></ama-form-factory-label-item>
      }
    </div>
  `,
                    imports: [LabelComponent, FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class TitleLayoutComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TitleLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: TitleLayoutComponent, isStandalone: true, selector: "ama-form-factory-title-layout", inputs: { item: "item" }, ngImport: i0, template: ` <div class="pt-5" [formFactory]="item"></div> `, isInline: true, dependencies: [{ kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TitleLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-title-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: ` <div class="pt-5" [formFactory]="item"></div> `,
                    imports: [FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class NoLayoutComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NoLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: NoLayoutComponent, isStandalone: true, selector: "ama-form-factory-no-layout", inputs: { item: "item" }, ngImport: i0, template: ` <ng-template [formFactory]="item"></ng-template> `, isInline: true, dependencies: [{ kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NoLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-no-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: ` <ng-template [formFactory]="item"></ng-template> `,
                    imports: [FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class RowLayoutComponent {
    constructor() {
        this.ITEMS_WITH_LABEL = ITEMS_WITH_LABEL;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RowLayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: RowLayoutComponent, isStandalone: true, selector: "ama-form-factory-row-layout", inputs: { item: "item" }, ngImport: i0, template: `
    <div class="form-group d-flex align-items-start justify-content-between mb-5">
      @if (item && ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-8 col-sm-7 col-md-6 col-lg-5 d-flex justify-content-end">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "ama-form-factory-label-item", inputs: ["itemName"] }, { kind: "directive", type: FormFactoryDirective, selector: "[formFactory]", inputs: ["formFactory"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: RowLayoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory-row-layout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    <div class="form-group d-flex align-items-start justify-content-between mb-5">
      @if (item && ITEMS_WITH_LABEL.includes(item.type)) {
        <ama-form-factory-label-item label [itemName]="item.itemName"></ama-form-factory-label-item>
      }
      <div class="col-8 col-sm-7 col-md-6 col-lg-5 d-flex justify-content-end">
        <ng-template [formFactory]="item"></ng-template>
      </div>
    </div>
  `,
                    imports: [LabelComponent, FormFactoryDirective]
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

const ITEM_TYPES = {
    boolean: BooleanComponent,
    enum: EnumComponent,
    integer: NumberComponent,
    label: LabelComponent,
    string: StringComponent,
    title: TitleComponent
};
const ITEMS_WITH_LABEL = ['boolean', 'enum', 'string', 'integer'];
const LAYOUT_TYPES = {
    modal: ModalLayoutComponent,
    column: ColumnLayoutComponent,
    row: RowLayoutComponent
};
const ITEM_LAYOUT_TYPES = {
    boolean: {
        modal: BooleanLayoutComponent,
        column: BooleanLayoutComponent,
        row: RowLayoutComponent
    },
    enum: LAYOUT_TYPES,
    integer: LAYOUT_TYPES,
    label: {
        modal: NoLayoutComponent,
        column: NoLayoutComponent,
        row: NoLayoutComponent
    },
    title: {
        modal: TitleLayoutComponent,
        column: TitleLayoutComponent,
        row: TitleLayoutComponent
    },
    string: LAYOUT_TYPES
};
const DEFAULT_LAYOUT = 'column';
var ValidatorTypes;
(function (ValidatorTypes) {
    ValidatorTypes["REQUIRED"] = "required";
    ValidatorTypes["EMAIL"] = "email";
    ValidatorTypes["MIN_LENGTH"] = "minlength";
    ValidatorTypes["MAX_LENGTH"] = "maxlength";
    ValidatorTypes["MIN"] = "min";
    ValidatorTypes["MAX"] = "max";
    ValidatorTypes["PATTERN"] = "pattern";
})(ValidatorTypes || (ValidatorTypes = {}));

class ValidatorsService {
    /**
     * Build a list of {@link ValidatorFn} based on validators descriptions
     * @param validators map of validators
     */
    buildFormValidators(validators) {
        return Object.keys(validators).map((validatorName) => {
            const value = validators[validatorName].value;
            switch (validatorName) {
                case ValidatorTypes.REQUIRED:
                    return Validators.required;
                case ValidatorTypes.EMAIL:
                    return Validators.email;
                case ValidatorTypes.MIN_LENGTH:
                    if (typeof value === 'number') {
                        return Validators.minLength(value);
                    }
                    else {
                        throw new Error('Min length validator should have a number value');
                    }
                case ValidatorTypes.MAX_LENGTH:
                    if (typeof value === 'number') {
                        return Validators.maxLength(value);
                    }
                    else {
                        throw new Error('Max length validator should have a number value');
                    }
                case ValidatorTypes.MIN:
                    if (typeof value === 'number') {
                        return Validators.min(value);
                    }
                    else {
                        throw new Error('Min validator should have a number value');
                    }
                case ValidatorTypes.MAX:
                    if (typeof value === 'number') {
                        return Validators.max(value);
                    }
                    else {
                        throw new Error('Max validator should have a number value');
                    }
                case ValidatorTypes.PATTERN:
                    if (typeof value === 'string') {
                        return Validators.pattern(value);
                    }
                    else {
                        throw new Error('Pattern validator should have a string value');
                    }
                default:
                    throw new Error('Unknown validator type');
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ValidatorsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ValidatorsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ValidatorsService, decorators: [{
            type: Injectable
        }] });

class FormFactoryService {
    constructor() {
        this.formBuilder = inject(FormBuilder);
        this.validatorService = inject(ValidatorsService);
        this.getItems = signal({});
        this.formGroup = this.formBuilder.group({});
    }
    get form() {
        return this.formGroup;
    }
    /**
     * Show a form item.
     * New items will be added to the form group if it has a default value.
     * If the item already exists, and it is shown, it will throw an error.
     * @param item
     */
    showFormItem(item) {
        if (this.getItems()[item.itemName]?.isShown) {
            throw new Error(`Item with name ${item.itemName} already exists`);
        }
        if (item.defaultValue !== null && item.defaultValue !== undefined) {
            const { metadata, itemName, defaultValue } = item;
            if (!this.form.contains(item.itemName)) {
                const validators = metadata?.validators ? this.validatorService.buildFormValidators(metadata.validators) : [];
                this.form.addControl(itemName, this.formBuilder.control(defaultValue, validators));
            }
            if (item.disabled) {
                this.form.get(item.itemName)?.disable();
            }
            else {
                this.form.get(item.itemName)?.enable();
            }
        }
        this.getItems.update((items) => ({
            ...items,
            [item.itemName]: {
                ...item,
                isShown: true
            }
        }));
    }
    /**
     * Hide the selected form item by flagging it as not shown
     * @param itemName
     */
    hideFormItem(itemName) {
        if (!this.getItems()[itemName]?.isShown) {
            throw new Error(`Item with name ${itemName} cannot be hidden`);
        }
        this.getItems.update((items) => ({
            ...items,
            [itemName]: {
                ...items[itemName],
                isShown: false
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryService, decorators: [{
            type: Injectable
        }] });

class LayoutFactoryDirective {
    constructor() {
        this.viewContainerRef = inject(ViewContainerRef);
    }
    set layoutFactory(layoutFactory) {
        if (layoutFactory) {
            this.viewContainerRef.clear();
            const component = this.viewContainerRef.createComponent(this.getLayout(layoutFactory));
            component.instance.item = layoutFactory;
        }
    }
    getLayout(layoutFactory) {
        return ITEM_LAYOUT_TYPES[layoutFactory.type][layoutFactory.layout];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LayoutFactoryDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: LayoutFactoryDirective, isStandalone: true, selector: "[layoutFactory]", inputs: { layoutFactory: "layoutFactory" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LayoutFactoryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[layoutFactory]',
                    standalone: true
                }]
        }], propDecorators: { layoutFactory: [{
                type: Input
            }] } });

class ObjectAssignPipe {
    transform(item, layout = DEFAULT_LAYOUT, disabled) {
        return { ...item, layout, disabled };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ObjectAssignPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ObjectAssignPipe, isStandalone: true, name: "objectAssign" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ObjectAssignPipe, decorators: [{
            type: Pipe,
            args: [{
                    standalone: true,
                    name: 'objectAssign'
                }]
        }] });

class FormFactoryComponent {
    constructor() {
        this.items = [];
        this.formFactoryService = inject(FormFactoryService);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: FormFactoryComponent, isStandalone: true, selector: "ama-form-factory", inputs: { items: "items", layout: "layout", disabled: "disabled" }, ngImport: i0, template: `
    <form [formGroup]="formFactoryService.form">
      @for (item of items; track item.itemName) {
        <ng-template [layoutFactory]="item | objectAssign: layout : !!disabled"></ng-template>
      }
    </form>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: LayoutFactoryDirective, selector: "[layoutFactory]", inputs: ["layoutFactory"] }, { kind: "pipe", type: ObjectAssignPipe, name: "objectAssign" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-form-factory',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    template: `
    <form [formGroup]="formFactoryService.form">
      @for (item of items; track item.itemName) {
        <ng-template [layoutFactory]="item | objectAssign: layout : !!disabled"></ng-template>
      }
    </form>
  `,
                    imports: [FormsModule, ReactiveFormsModule, LayoutFactoryDirective, ObjectAssignPipe]
                }]
        }], propDecorators: { items: [{
                type: Input
            }], layout: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class FormFactoryUtilsService {
    /**
     * Check if the conditions are met for the given configuration
     * @param conditions list of conditions
     * @param configuration key-value pairs of configuration
     */
    areConditionsMet(conditions = [], configuration) {
        return conditions.every((condition) => this.isConditionMet(condition, configuration));
    }
    /**
     * Check if the condition is met for the given configuration
     * @param condition condition to check
     * @param configuration key-value pairs of configuration
     */
    isConditionMet(condition, configuration) {
        if (typeof condition === 'string') {
            return !!configuration[condition];
        }
        if (condition.operator === 'equals') {
            return configuration[condition.name] === condition.value;
        }
        if (condition.operator === 'notEquals') {
            return configuration[condition.name] !== condition.value;
        }
        throw new Error('Unsupported condition operator');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryUtilsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormFactoryUtilsService, decorators: [{
            type: Injectable
        }] });

/* eslint-disable @typescript-eslint/unified-signatures */
class ReefCurrencyPipe extends CurrencyPipe {
    constructor(locale, defaultCurrencyCode) {
        super(locale, defaultCurrencyCode);
        this.NO_VALUE = '-';
    }
    transform(value, currencyCode, display = 'code', digitsInfo, locale) {
        // If value is not a number and evaluates to false ('', null, undefined) return the NO_VALUE placeholder
        if (Number.isNaN(value) || (typeof value !== 'number' && !value)) {
            return this.NO_VALUE;
        }
        let result = super.transform(value, currencyCode, display, digitsInfo, locale);
        if (result) {
            // Add space between currency code and value when display is 'code'
            // https://github.com/angular/angular/issues/20708
            if (currencyCode && display === 'code') {
                const replace = result.endsWith(currencyCode) ? `\u00A0${currencyCode}` : `${currencyCode}\u00A0`;
                result = result.replace(new RegExp(`\\s*${currencyCode}\\s*`), replace);
            }
            // Replace dash with Unicode minus sign for negative values
            result = result.replace('-', '\u2212');
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefCurrencyPipe, deps: [{ token: LOCALE_ID }, { token: DEFAULT_CURRENCY_CODE }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ReefCurrencyPipe, name: "reefCurrency" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'reefCurrency' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DEFAULT_CURRENCY_CODE]
                }] }] });

const LOCALE_DATA = {
    '12H': {
        'en-GB': {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd/MM/y, h:mm a',
            medium: 'd MMM y, h:mm:ss a',
            long: "{d MMMM y 'at' h:mm:ss a z",
            full: "EEEE, d MMMM y 'at' h:mm:ss a zzzz"
        },
        fr: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd/MM/y h:mm a',
            medium: 'd MMM y, h:mm:ss a',
            long: "d MMMM y 'à' h:mm:ss a z",
            full: "EEEE d MMMM y 'à' h:mm:ss a zzzz"
        },
        de: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd.MM.yy, h:mm a',
            medium: 'dd.MM.y, h:mm:ss a',
            long: "d. MMMM y 'um' h:mm:ss a z",
            full: "EEEE, d. MMMM y 'um' h:mm:ss a zzzz"
        },
        zh: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'z h:mm:ss a',
            fullTime: 'zzzz h:mm:ss a',
            short: 'y/M/d h:mm a',
            medium: 'y年M月d日 h:mm:ss a',
            long: 'y年M月d日 z h:mm:ss a',
            full: 'y年M月d日EEEE zzzz h:mm:ss a'
        },
        es: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'H:mm:ss a (zzzz)',
            short: 'd/M/yy, h:mm a',
            medium: 'd MMM y, h:mm:ss a',
            long: "d 'de' MMMM 'de' y, h:mm:ss a z",
            full: "EEEE, d 'de' MMMM 'de' y, H:mm:ss a (zzzz)"
        },
        it: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd/MM/yy, h:mm a',
            medium: 'd MMM y, h:mm:ss a',
            long: 'd MMMM y h:mm:ss a z',
            full: 'EEEE d MMMM y h:mm:ss a zzzz'
        },
        ja: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h時mm分ss秒 a zzzz',
            short: 'y/MM/dd h:mm a',
            medium: 'y/MM/dd h:mm:ss a',
            long: 'y年M月d日 h:mm:ss a z',
            full: 'y年M月d日EEEE h時mm分ss秒 a zzzz'
        },
        br: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd/MM/y h:mm a',
            medium: "d 'de' MMM 'de' y h:mm:ss a",
            long: "d 'de' MMMM 'de' y h:mm:ss a z",
            full: "EEEE, d 'de' MMMM 'de' y h:mm:ss a zzzz"
        },
        ru: {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'dd.MM.y, h:mm a',
            medium: "d MMM y 'г'., h:mm:ss a",
            long: "d MMMM y 'г'., ",
            full: "EEEE, d MMMM y 'г'., h:mm:ss a zzzz"
        },
        'zh-Hant': {
            shortTime: 'h:mm a',
            mediumTime: 'h:mm:ss a',
            longTime: 'h:mm:ss a z',
            fullTime: 'h:mm:ss a zzzz',
            short: 'y/M/d h:mm a',
            medium: 'y年M月d日 h:mm:ss a',
            long: 'y年M月d日 h:mm:ss a z',
            full: 'y年M月d日 EEEE h:mm:ss a zzzz'
        }
    },
    '24H': {
        'en-US': {
            shortTime: 'HH:mm',
            mediumTime: 'HH:mm:ss',
            longTime: 'HH:mm:ss z',
            fullTime: 'HH:mm:ss zzzz',
            short: 'M/d/yy, HH:mm',
            medium: 'MMM d, y, HH:mm:ss',
            long: "MMMM d, y 'at' HH:mm:ss z",
            full: "EEEE, MMMM d, y 'at' HH:mm:ss zzzz"
        },
        ko: {
            shortTime: 'HH:mm',
            mediumTime: 'HH:mm:ss',
            longTime: 'HH시 m분 s초 z',
            fullTime: 'HH시 m분 s초 zzzz',
            short: 'yy. M. d. HH:mm',
            medium: 'y. M. d. HH:mm:ss',
            long: 'y년 M월 d일 HH시 m분 s초 z',
            full: 'y년 M월 d일 EEEE HH시 m분 s초 zzzz'
        }
    }
};

const OFFICE_DISPLAY = {
    requestType: {
        messageFunctionDetails: {
            messageFunction: 'V20',
            codeListAgency: '1A'
        }
    },
    displayOptions: {
        oidField: ['TCM']
    }
};
const MERIDIEM_FORMAT = { N: '24H', Y: '12H' };
class ReefMeridiemI18nService {
    constructor(bearService) {
        this.bearService = bearService;
    }
    init() {
        this.getTCMConfig();
    }
    getTimeFormat() {
        return this.timeFormat;
    }
    getTCMConfig() {
        this.bearService
            .officeDisplay(OFFICE_DISPLAY)
            .pipe(take(1))
            .subscribe((officeDisplayReply) => {
            const fieldStructure = officeDisplayReply?.fieldStructure;
            if (fieldStructure) {
                const TCMValue = fieldStructure.find((field) => field.fieldDetails?.oidField === 'TCM')?.fieldValue
                    ?.valueYesNo;
                if (TCMValue) {
                    this.timeFormat = MERIDIEM_FORMAT[TCMValue];
                }
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefMeridiemI18nService, deps: [{ token: i1$2.Bear1AXMLService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefMeridiemI18nService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefMeridiemI18nService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Bear1AXMLService }] });

class ReefDatePipe extends DatePipe {
    // ReefMeridiemI18nService is kept optional and allow to use office profile configuration (TCM) for 12/24h instead of language setting
    // It is provided and initialized in ngLoader for SECO
    // If not provided, the language setting from angular is used
    constructor(localeId, reefMeridiemI18nService) {
        super(localeId);
        this.localeId = localeId;
        this.reefMeridiemI18nService = reefMeridiemI18nService;
        /**
         * All formats that have to be localized.
         */
        this.formatsTobeLocalized = [
            // Angular predefined formats that can be found: https://angular.io/api/common/DatePipe
            'short',
            'medium',
            'long',
            'full',
            'shortDate',
            'mediumDate',
            'longDate',
            'fullDate',
            'shortTime',
            'mediumTime',
            'longTime',
            'fullTime',
            // Custom format authorized
            'EEEE'
        ];
    }
    transform(value, format, timezone, locale) {
        const timeFormat = this.reefMeridiemI18nService?.getTimeFormat();
        const localToApply = locale || (format && this.formatsTobeLocalized.includes(format)) ? locale : 'en-US';
        let formatToApply = format;
        if (timeFormat &&
            format &&
            this.formatsTobeLocalized.includes(format) &&
            LOCALE_DATA[timeFormat]?.[localToApply || this.localeId]) {
            formatToApply = this.getMeridiemDateTimeFormat(format, LOCALE_DATA[timeFormat][localToApply || this.localeId]);
        }
        return super.transform(value, formatToApply, timezone, localToApply);
    }
    getMeridiemDateTimeFormat(format, localeData) {
        return localeData[format] || format;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefDatePipe, deps: [{ token: LOCALE_ID }, { token: ReefMeridiemI18nService, optional: true }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ReefDatePipe, name: "reefDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'reefDate',
                    pure: true
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: ReefMeridiemI18nService, decorators: [{
                    type: Inject,
                    args: [ReefMeridiemI18nService]
                }, {
                    type: Optional
                }] }] });

class ReefDatepickerI18n extends NgbDatepickerI18nDefault {
    constructor() {
        super(...arguments);
        this.locale = inject(LOCALE_ID);
    }
    // overriding labels for Asian locales
    getMonthLabel(date) {
        switch (this.locale) {
            case 'ja':
            case 'zh-Hant':
                return `${date.year}年${super.getMonthFullName(date.month)}`;
            case 'zh':
                return `${date.year}年${date.month}月`;
            case 'ko':
                return `${date.year}년 ${super.getMonthFullName(date.month)}`;
            default:
                return super.getMonthLabel(date);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefDatepickerI18n, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefDatepickerI18n }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefDatepickerI18n, decorators: [{
            type: Injectable
        }] });

class ReefI18nModule {
    static forRoot(includedNgBootstrapDeps = true) {
        return {
            ngModule: ReefI18nModule,
            providers: [
                ReefDatePipe,
                ReefCurrencyPipe,
                ...(includedNgBootstrapDeps ? [{ provide: NgbDatepickerI18n, useClass: ReefDatepickerI18n }] : [])
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefI18nModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ReefI18nModule, declarations: [ReefDatePipe, ReefCurrencyPipe], exports: [ReefDatePipe, ReefCurrencyPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefI18nModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ReefI18nModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ReefDatePipe, ReefCurrencyPipe],
                    exports: [ReefDatePipe, ReefCurrencyPipe]
                }]
        }] });

class ModalBodyDirective {
    constructor(bodyContainerRef) {
        this.bodyContainerRef = bodyContainerRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalBodyDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: ModalBodyDirective, selector: "[amaModalBody]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalBodyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amaModalBody]'
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }] });

class ModalButtons {
    constructor(label, btnClass, callbackFunction, returnValue, doNotCloseModal) {
        this.label = label;
        this.btnClass = btnClass;
        this.callbackFunction = callbackFunction;
        this.returnValue = returnValue;
        this.doNotCloseModal = doNotCloseModal;
    }
}

class ModalConfiguration {
    constructor(topCross, alertType, checkbox, modalOptions, titleSize, bodyNoPadding) {
        this.topCross = topCross;
        this.alertType = alertType;
        this.checkbox = checkbox;
        this.modalOptions = modalOptions;
        this.titleSize = titleSize;
        this.bodyNoPadding = bodyNoPadding;
    }
}

class ModalManagerComponent {
    constructor(activeModal, sanitizer, localStorageService) {
        this.activeModal = activeModal;
        this.sanitizer = sanitizer;
        this.localStorageService = localStorageService;
        this.bodyIsComponent = false;
        this.hasCheckbox = false;
        this.doNotShowCheckbox = false;
        this.contentInjector = inject(Injector);
        this.environmentInjector = inject(EnvironmentInjector);
        this.appRef = inject(ApplicationRef);
    }
    ngOnInit() {
        if (typeof this.body !== 'string') {
            this.bodyIsComponent = true;
            this.loadComponent();
        }
        else {
            // Bypass in order to have inline style working
            this.body = this.sanitizer.bypassSecurityTrustHtml(this.body);
        }
        if (this.checkboxStorage &&
            this.checkboxStorage.length !== 0 &&
            this.checkboxLabel &&
            this.checkboxLabel.length !== 0) {
            this.hasCheckbox = true;
            this.getLocalStorage();
        }
    }
    onDoNotShowCheck(value) {
        if (!this.checkboxStorage) {
            return;
        }
        this.localStorageService.setItem(this.checkboxStorage, value);
        this.doNotShowCheckbox = value;
    }
    close(btn) {
        const hasOutputData = this.componentRef && this.componentRef.instance.hasOwnProperty('outputData');
        const returnValue = this.componentRef && hasOutputData ? this.componentRef.instance.outputData : undefined;
        if (btn.callbackFunction) {
            if (hasOutputData) {
                btn.callbackFunction(returnValue);
            }
            else {
                btn.callbackFunction();
            }
        }
        if (!btn.doNotCloseModal) {
            this.activeModal.close(btn.returnValue ? returnValue : undefined);
        }
    }
    loadComponent() {
        const componentRef = createComponent(this.body, {
            environmentInjector: this.contentInjector.get(EnvironmentInjector, null) || this.environmentInjector,
            elementInjector: this.contentInjector
        });
        this.componentRef = componentRef;
        this.bodyHost.bodyContainerRef.insert(componentRef.hostView);
        const data = this.bodyComponentData;
        if (data) {
            const instance = componentRef.instance;
            for (const key of Object.keys(data)) {
                instance[key] = data[key];
            }
        }
    }
    getLocalStorage() {
        if (!this.checkboxStorage) {
            return;
        }
        const localStorageTestModal = this.localStorageService.getItem(this.checkboxStorage);
        if (localStorageTestModal) {
            this.doNotShowCheckbox = JSON.parse(localStorageTestModal);
        }
        else {
            this.doNotShowCheckbox = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerComponent, deps: [{ token: i1.NgbActiveModal }, { token: i2$1.DomSanitizer }, { token: LocalStorageService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ModalManagerComponent, selector: "ama-modal-manager", inputs: { title: "title", body: "body", footer: "footer", topCross: "topCross", checkboxStorage: "checkboxStorage", checkboxLabel: "checkboxLabel", alertType: "alertType", titleSize: "titleSize", bodyNoPadding: "bodyNoPadding", bodyComponentData: "bodyComponentData", uniqueId: "uniqueId" }, viewQueries: [{ propertyName: "bodyHost", first: true, predicate: ModalBodyDirective, descendants: true, static: true }], ngImport: i0, template: "<div\n  class=\"modal-header\"\n  [class.df-warning-modal]=\"alertType === 'warning'\"\n  [class.df-info-modal]=\"alertType === 'info'\"\n  [class.df-error-modal]=\"alertType === 'error'\"\n  [class.df-success-modal]=\"alertType === 'success'\"\n  [class.border-bottom-0]=\"!!alertType\"\n  [class.pt-6]=\"!!alertType\"\n>\n  <span\n    *ngIf=\"alertType\"\n    aria-hidden=\"true\"\n    class=\"alert-modal-icon me-4\"\n    [class.fa-check-circle]=\"alertType === 'success'\"\n    [class.text-success]=\"alertType === 'success'\"\n    [class.fa-exclamation-triangle]=\"alertType === 'warning'\"\n    [class.fa-info-circle]=\"alertType === 'info'\"\n    [class.fa-minus-circle]=\"alertType === 'error'\"\n  ></span>\n  <h2 [ngClass]=\"{ h4: titleSize === 'small' }\" class=\"modal-title\">\n    {{ title }}\n  </h2>\n  <button *ngIf=\"topCross === true\" type=\"button\" class=\"btn-close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n  </button>\n</div>\n<div class=\"modal-body\" [class.p-0]=\"bodyNoPadding\">\n  <ng-template amaModalBody> </ng-template>\n  <ng-container *ngIf=\"!bodyIsComponent\">\n    <p class=\"line-breaker\" [innerHTML]=\"body\"></p>\n    <div *ngIf=\"hasCheckbox === true\" class=\"mb-5 modal-checkbox\">\n      <div class=\"form-check\">\n        <input\n          type=\"checkbox\"\n          class=\"form-check-input do-not-checkbox\"\n          id=\"doNotShowCheck_{{ this.uniqueId }}\"\n          [checked]=\"doNotShowCheckbox\"\n          (change)=\"onDoNotShowCheck(doNotShowCheck.checked)\"\n          #doNotShowCheck\n        />\n        <label class=\"form-check-label\" for=\"doNotShowCheck_{{ this.uniqueId }}\">{{ checkboxLabel }}</label>\n      </div>\n    </div>\n  </ng-container>\n</div>\n<div\n  *ngIf=\"footer && footer.length > 0\"\n  class=\"modal-footer\"\n  [class.border-top-0]=\"!!alertType\"\n  [class.pb-6]=\"!!alertType\"\n>\n  <ng-container *ngFor=\"let btn of footer; let btnIndex = index\">\n    <button\n      type=\"button\"\n      class=\"btn btn-{{ btn.btnClass }}\"\n      [class.me-3]=\"btnIndex !== footer.length - 1\"\n      (click)=\"close(btn)\"\n    >\n      {{ btn.label }}\n    </button>\n  </ng-container>\n</div>\n", styles: [".line-breaker{white-space:pre-line}.modal-checkbox{margin-bottom:0}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ModalBodyDirective, selector: "[amaModalBody]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-modal-manager', template: "<div\n  class=\"modal-header\"\n  [class.df-warning-modal]=\"alertType === 'warning'\"\n  [class.df-info-modal]=\"alertType === 'info'\"\n  [class.df-error-modal]=\"alertType === 'error'\"\n  [class.df-success-modal]=\"alertType === 'success'\"\n  [class.border-bottom-0]=\"!!alertType\"\n  [class.pt-6]=\"!!alertType\"\n>\n  <span\n    *ngIf=\"alertType\"\n    aria-hidden=\"true\"\n    class=\"alert-modal-icon me-4\"\n    [class.fa-check-circle]=\"alertType === 'success'\"\n    [class.text-success]=\"alertType === 'success'\"\n    [class.fa-exclamation-triangle]=\"alertType === 'warning'\"\n    [class.fa-info-circle]=\"alertType === 'info'\"\n    [class.fa-minus-circle]=\"alertType === 'error'\"\n  ></span>\n  <h2 [ngClass]=\"{ h4: titleSize === 'small' }\" class=\"modal-title\">\n    {{ title }}\n  </h2>\n  <button *ngIf=\"topCross === true\" type=\"button\" class=\"btn-close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n  </button>\n</div>\n<div class=\"modal-body\" [class.p-0]=\"bodyNoPadding\">\n  <ng-template amaModalBody> </ng-template>\n  <ng-container *ngIf=\"!bodyIsComponent\">\n    <p class=\"line-breaker\" [innerHTML]=\"body\"></p>\n    <div *ngIf=\"hasCheckbox === true\" class=\"mb-5 modal-checkbox\">\n      <div class=\"form-check\">\n        <input\n          type=\"checkbox\"\n          class=\"form-check-input do-not-checkbox\"\n          id=\"doNotShowCheck_{{ this.uniqueId }}\"\n          [checked]=\"doNotShowCheckbox\"\n          (change)=\"onDoNotShowCheck(doNotShowCheck.checked)\"\n          #doNotShowCheck\n        />\n        <label class=\"form-check-label\" for=\"doNotShowCheck_{{ this.uniqueId }}\">{{ checkboxLabel }}</label>\n      </div>\n    </div>\n  </ng-container>\n</div>\n<div\n  *ngIf=\"footer && footer.length > 0\"\n  class=\"modal-footer\"\n  [class.border-top-0]=\"!!alertType\"\n  [class.pb-6]=\"!!alertType\"\n>\n  <ng-container *ngFor=\"let btn of footer; let btnIndex = index\">\n    <button\n      type=\"button\"\n      class=\"btn btn-{{ btn.btnClass }}\"\n      [class.me-3]=\"btnIndex !== footer.length - 1\"\n      (click)=\"close(btn)\"\n    >\n      {{ btn.label }}\n    </button>\n  </ng-container>\n</div>\n", styles: [".line-breaker{white-space:pre-line}.modal-checkbox{margin-bottom:0}\n"] }]
        }], ctorParameters: () => [{ type: i1.NgbActiveModal }, { type: i2$1.DomSanitizer }, { type: LocalStorageService }], propDecorators: { bodyHost: [{
                type: ViewChild,
                args: [ModalBodyDirective, { static: true }]
            }], title: [{
                type: Input
            }], body: [{
                type: Input
            }], footer: [{
                type: Input
            }], topCross: [{
                type: Input
            }], checkboxStorage: [{
                type: Input
            }], checkboxLabel: [{
                type: Input
            }], alertType: [{
                type: Input
            }], titleSize: [{
                type: Input
            }], bodyNoPadding: [{
                type: Input
            }], bodyComponentData: [{
                type: Input
            }], uniqueId: [{
                type: Input
            }] } });

class ModalManagerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerModule, declarations: [ModalManagerComponent, ModalBodyDirective], imports: [CommonModule, NgbModalModule], exports: [ModalManagerComponent, ModalBodyDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerModule, imports: [CommonModule, NgbModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbModalModule],
                    declarations: [ModalManagerComponent, ModalBodyDirective],
                    exports: [ModalManagerComponent, ModalBodyDirective]
                }]
        }] });

class ModalManagerService {
    constructor(dfModalService) {
        this.dfModalService = dfModalService;
        this.currentModalId = 0;
        this.modalRef = null;
        this.keyboardOptions = false;
    }
    createModal(title, body, footer, config, bodyComponentData) {
        if (config && config.modalOptions) {
            if (!config.modalOptions.container) {
                config.modalOptions.container = '.design-factory-v2';
            }
            this.modalRef = this.dfModalService.open(ModalManagerComponent, config.modalOptions);
        }
        else {
            this.modalRef = this.dfModalService.open(ModalManagerComponent, { container: '.design-factory-v2' });
        }
        this.modalRef.componentInstance.title = title;
        if (typeof body === 'string') {
            body = body.replace(/\\n/g, '\n');
        }
        this.modalRef.componentInstance.body = body;
        this.modalRef.componentInstance.footer = footer;
        if (bodyComponentData) {
            this.modalRef.componentInstance.bodyComponentData = bodyComponentData;
        }
        if (config) {
            this.modalRef.componentInstance.alertType = config.alertType;
            this.modalRef.componentInstance.topCross = config.topCross;
            this.modalRef.componentInstance.titleSize = config.titleSize;
            this.modalRef.componentInstance.bodyNoPadding = config.bodyNoPadding;
            if (config.checkbox) {
                this.modalRef.componentInstance.uniqueId = this.currentModalId;
                this.currentModalId++;
                this.modalRef.componentInstance.checkboxStorage = config.checkbox.localStorage;
                this.modalRef.componentInstance.checkboxLabel = config.checkbox.checkboxLabel;
            }
        }
        else {
            this.modalRef.componentInstance.topCross = true;
        }
        this.keyboardOptions = !!config?.modalOptions?.keyboard;
        return from(this.modalRef.result);
    }
    createModalInSeco(title, body, footer, config, bodyComponentData) {
        if (!(config && config.modalOptions && config.modalOptions.container)) {
            let modalOptions = config && config.modalOptions ? config.modalOptions : {};
            modalOptions = Object.assign({}, { container: '.design-factory-v2.modal-manager' }, modalOptions);
            config = Object.assign({}, config, { modalOptions });
        }
        return this.createModal(title, body, footer, config, bodyComponentData);
    }
    //TODO this function will no longer be needed when Aria will be removed.  keyboardOptions will also be no longer used.
    handleEscapeEvent() {
        if (this.modalRef && this.keyboardOptions) {
            this.modalRef.close();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerService, deps: [{ token: i1$4.DfModalService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$4.DfModalService }] });

const beforeDismissAction = createAction('[Modal Manager] Before dismiss callback', props());

class ModalSpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerModule, imports: [CommonModule, DfProgressIndicatorModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerModule, providers: [ActionsSubject], imports: [CommonModule, DfProgressIndicatorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DfProgressIndicatorModule],
                    providers: [ActionsSubject]
                }]
        }] });

class ModalSpinnerService {
    constructor(progressIndicatorService, actionsSubject) {
        this.progressIndicatorService = progressIndicatorService;
        this.actionsSubject = actionsSubject;
        this.subs = new Subscription();
        this.displayConditions = [];
        this.hideConditions = [];
        this.spinnerCounter = 0;
        this.subs.add(this.actionsSubject.subscribe((data) => {
            if (this.displayConditions.indexOf(data.type) > -1) {
                this.displaySpinner();
            }
            if (this.hideConditions.indexOf(data.type) > -1) {
                this.hideSpinner();
            }
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /**
     * Displays a full screen modal spinner
     */
    displaySpinner() {
        this.spinnerCounter++;
        if (this.spinnerRef === undefined) {
            const dfNamespaceClass = 'design-factory-v2';
            this.spinnerRef = this.progressIndicatorService.open(undefined, {
                containerClass: dfNamespaceClass,
                backdropClass: dfNamespaceClass
            });
        }
    }
    /**
     * Displays a spinner binded to a task
     * @param domElem - HTMLElement under which the spinner will be appended
     */
    displayTaskOverlay(domElem) {
        this.spinnerCounter++;
        if (this.spinnerRef === undefined) {
            const dfNamespaceClass = 'design-factory-v2 taskOverlay';
            this.spinnerRef = this.progressIndicatorService.open(undefined, {
                container: domElem,
                containerClass: dfNamespaceClass,
                backdropClass: dfNamespaceClass
            });
        }
    }
    /**
     * Removes the modal spinner from the DOM
     */
    hideSpinner() {
        this.spinnerCounter = Math.max(0, this.spinnerCounter - 1);
        if (this.spinnerCounter === 0 && this.spinnerRef !== undefined) {
            this.progressIndicatorService.close(this.spinnerRef);
            this.spinnerRef = undefined;
        }
    }
    /**
     * Register a listener to display and close a modal spinner
     * on action dispatch on the Store
     *
     * @param showOn array of action types that trigger a spinner display
     * @param hideOn array of action types that trigger a spinner removal
     */
    registerSpinner(showOn, hideOn) {
        this.displayConditions.push(...showOn);
        this.hideConditions.push(...hideOn);
    }
    /**
     * Removes the specified lists of actions from the listener
     *
     * @param showOn array of action types that will not trigger a spinner display anymore
     * @param hideOn array of action types that will not trigger a spinner removal anymore
     */
    unregisterSpinner(showOn, hideOn) {
        showOn.forEach((s) => {
            // Avoid deleting the last element of the array if the action was not registered
            const index = this.displayConditions.indexOf(s);
            if (index >= 0) {
                this.displayConditions.splice(index, 1);
            }
        });
        hideOn.forEach((s) => {
            // Avoid deleting the last element of the array if the action was not registered
            const index = this.hideConditions.indexOf(s);
            if (index >= 0) {
                this.hideConditions.splice(index, 1);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerService, deps: [{ token: i1$4.DfProgressIndicatorService }, { token: i3.ActionsSubject }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ModalSpinnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$4.DfProgressIndicatorService }, { type: i3.ActionsSubject }] });

var ToastStylesEnum;
(function (ToastStylesEnum) {
    ToastStylesEnum["WARNING"] = "warning";
    ToastStylesEnum["DANGER"] = "danger";
    ToastStylesEnum["INFO"] = "info";
    ToastStylesEnum["SUCCESS"] = "success";
})(ToastStylesEnum || (ToastStylesEnum = {}));

class ToastComponent {
    constructor() {
        this.closed = new EventEmitter();
    }
    close() {
        this.closed.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ToastComponent, selector: "ng-component", inputs: { toast: "toast" }, outputs: { closed: "closed" }, ngImport: i0, template: "<ngb-toast\n  dfInsertToastIcon\n  class=\"mb-3\"\n  [class]=\"'toast-' + toast.style\"\n  [class.df-toast-subtle]=\"toast.light\"\n  [class.df-toast-dismissible]=\"toast.closable\"\n  [autohide]=\"false\"\n  >{{ toast.message }}\n  <button\n    *ngIf=\"toast.closable\"\n    type=\"button\"\n    aria-label=\"Close this toast message\"\n    i18n-aria-label=\"@@core.toast.close\"\n    class=\"btn-close\"\n    (click)=\"close()\"\n  ></button>\n</ngb-toast>\n", dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1.NgbToast, selector: "ngb-toast", inputs: ["animation", "delay", "autohide", "header"], outputs: ["shown", "hidden"], exportAs: ["ngbToast"] }, { kind: "directive", type: i1$4.DfInsertIconDirective, selector: "ngb-alert[dfInsertAlertIcon],ngb-toast[dfInsertToastIcon]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ template: "<ngb-toast\n  dfInsertToastIcon\n  class=\"mb-3\"\n  [class]=\"'toast-' + toast.style\"\n  [class.df-toast-subtle]=\"toast.light\"\n  [class.df-toast-dismissible]=\"toast.closable\"\n  [autohide]=\"false\"\n  >{{ toast.message }}\n  <button\n    *ngIf=\"toast.closable\"\n    type=\"button\"\n    aria-label=\"Close this toast message\"\n    i18n-aria-label=\"@@core.toast.close\"\n    class=\"btn-close\"\n    (click)=\"close()\"\n  ></button>\n</ngb-toast>\n" }]
        }], propDecorators: { toast: [{
                type: Input
            }], closed: [{
                type: Output
            }] } });

class ToastManagerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerModule, declarations: [ToastComponent], imports: [CommonModule, DfToastModule], exports: [ToastComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerModule, imports: [CommonModule, DfToastModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ToastComponent],
                    imports: [CommonModule, DfToastModule],
                    exports: [ToastComponent]
                }]
        }] });

const DEFAULT_TOAST_CONFIG = {
    timeout: 5000,
    closable: false,
    style: ToastStylesEnum.SUCCESS,
    light: true
};
class ToastManagerService {
    constructor(rendererFactory, applicationRef, injector, document) {
        this.rendererFactory = rendererFactory;
        this.applicationRef = applicationRef;
        this.injector = injector;
        this.document = document;
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    show(message, config = { ...DEFAULT_TOAST_CONFIG }) {
        const configToApply = { ...DEFAULT_TOAST_CONFIG, ...config };
        const toast = {
            message,
            closable: configToApply.closable,
            light: configToApply.light,
            style: configToApply.style,
            timeout: configToApply.timeout
        };
        this.addToToastContainer(toast);
    }
    addToToastContainer(toast) {
        const componentRef = createComponent(ToastComponent, {
            environmentInjector: this.applicationRef.injector
        });
        componentRef.setInput('toast', toast);
        this.applicationRef.attachView(componentRef.hostView);
        const domElem = componentRef.location.nativeElement;
        const rootElem = this.getToastContainerElem();
        this.renderer.appendChild(rootElem, domElem);
        if (toast.timeout > 0) {
            const closeEvent = componentRef.instance.closed.asObservable();
            const timeout = timer(toast.timeout);
            race(closeEvent, timeout).subscribe(() => this.removeToast(componentRef));
        }
    }
    getToastContainerElem() {
        if (!this.document.querySelector('.toast-container')) {
            const dfContainer = this.renderer.createElement('div');
            this.renderer.addClass(dfContainer, 'design-factory-v2');
            const toastContainer = this.renderer.createElement('div');
            ['toast-container', 'position-fixed', 'top-0', 'start-50', 'translate-middle-x', 'mt-10', 'me-5'].forEach((className) => this.renderer.addClass(toastContainer, className));
            this.renderer.setStyle(toastContainer, 'z-index', '1000');
            const body = this.renderer.selectRootElement('body', true);
            this.renderer.appendChild(dfContainer, toastContainer);
            this.renderer.appendChild(body, dfContainer);
        }
        return this.renderer.selectRootElement('.toast-container', true);
    }
    removeToast(componentRef) {
        componentRef.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerService, deps: [{ token: i0.RendererFactory2 }, { token: i0.ApplicationRef }, { token: i0.Injector }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ToastManagerService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.RendererFactory2 }, { type: i0.ApplicationRef }, { type: i0.Injector }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class Messages {
}

class ResolvePlaceholdersService {
    /**
     * This function, given a message with placeholder (ex: "{0}", "{1}"), will replace the placeholder by the value
     * inside 'args' input. '{0}' will be replaced by the first 'args' value, "{1}" by the 2nd etc.
     * @param message
     * @param args
     */
    resolvePlaceholders(message, args) {
        if (args && args.length) {
            return args.reduce((msg, arg, i) => msg.replace(`{${i}}`, arg), message);
        }
        return message;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersService, decorators: [{
            type: Injectable
        }] });

class ResolvePlaceholdersPipe {
    constructor(resolvePlaceholdersService) {
        this.resolvePlaceholdersService = resolvePlaceholdersService;
    }
    transform(message, ...args) {
        return this.resolvePlaceholdersService.resolvePlaceholders(message, args);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersPipe, deps: [{ token: ResolvePlaceholdersService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersPipe, name: "resolvePlaceholders" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'resolvePlaceholders'
                }]
        }], ctorParameters: () => [{ type: ResolvePlaceholdersService }] });

class ResolvePlaceholdersModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersModule, declarations: [ResolvePlaceholdersPipe], exports: [ResolvePlaceholdersPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersModule, providers: [ResolvePlaceholdersService] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ResolvePlaceholdersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ResolvePlaceholdersPipe],
                    providers: [ResolvePlaceholdersService],
                    exports: [ResolvePlaceholdersPipe]
                }]
        }] });

// Directives

/**
 * Generated bundle index. Do not edit.
 */

export { ALERT_MANAGER_FEATURE, AlertManagerComponent, AlertManagerModule, AlertManagerService, Analytics, AnalyticsArguments, AnalyticsLogLevel, AnalyticsService, ArrayHelper, AshService, Audience, AutofocusDirective, Bear1AXMLRSFService, Bear1AXMLServiceMock, CONFIG_TOKEN, ClpAuthService, ConfigTokenService, ContextService, CoreDirectivesModule, CorePipesModule, CreditCardConcealmentService, CrypticUtilService, CustomizationOrchestratorService, DEFAULT_DELAY_BETWEEN_RETRIES_MS, DEFAULT_LAYOUT, DEFAULT_TIMEOUT_IN_MS, DacErrorResponse, DacResponse, DacType, DateHelper, DateMode, DefaultTextPipe, DeviceSize, ENVIRONMENT, EquipmentsService, FormFactoryComponent, FormFactoryService, FormFactoryUtilsService, GlobalListsCacheUtil, HTTP_CONFIG_TOKEN, Http1AXMLService, Http1AXMLServiceImpl, HttpConfigService, HttpService, ITEMS_WITH_LABEL, ITEM_LAYOUT_TYPES, ITEM_TYPES, IdGenerationDirective, IdGenerationModule, JWT_TYPE_NAME, KeyBinding, KeysPipe, LANGUAGE_CODE_MAP, LAYOUT_TYPES, LocalStorageService, MAXRESPONSE, MessageComponent, MessageType, Messages, MessagesSectionComponent, MessagesSectionModule, MessagesSectionService, ModalBodyDirective, ModalButtons, ModalConfiguration, ModalManagerComponent, ModalManagerModule, ModalManagerService, ModalSpinnerModule, ModalSpinnerService, NAVIGATE, NameFormatterPipe, Navigate, NgbDOBDatepickerDirective, NgbDateIataFormatter, NodeType, OPEN_NEW_CMD_PAGE, OpenNewCmdPage, PNRRET_ERROR_PNR_SESSION, PROFILE_OPEN_ASSOC, PROFILE_REQUEST_VERSION, PROFILE_STATUS, PROFILE_TRANSFER_PRF_BF, PROFILE_TYPE_CODE, PROFILE_UPDATE_TOP_BAR, PnrAccParser, PnrOptions, PnrRetErrorMapping, PrefixConfigService, ProbeTaskType, ProfileOpenAssocPrf, ProfileTransferPrfBF, ProfileUpdateTopBar, PropertyHelper, QmCommands, QmTriggerOrigins, QualityMonitorService, QueueService, ReactiveFormUtilsService, ReefApiGatewayService, ReefAppModule, ReefConfigurationService, ReefCurrencyPipe, ReefDatePipe, ReefDatepickerI18n, ReefGatewayService, ReefHeaders, ReefI18nModule, ReefKeepAliveService, ReefMeridiemI18nService, ReefRESTService, ReefServerModule, ReefTokenInterceptor, ReefTokenService, RemoveHtmlAttributesPipe, RenewReefAccessTokenService, ResolvePlaceholdersModule, ResolvePlaceholdersPipe, ResolvePlaceholdersService, ResponsiveDirectivesModule, ScrollSpyDirective, SentenceCasePipe, ShouldDisplayOnDeviceDirective, StringHelper, TaskTokenService, ToastComponent, ToastManagerModule, ToastManagerService, ToastStylesEnum, UNIQUE_ID_TYPE, URLUtils, UrlParametersUtil, UserPreferencesService, ValidatorTypes, ValidatorsService, alertManagerReducer, apfExtractResourceData, assertNotNull, assertNotNull$, beforeDismissAction, constructApfPlusGlobalsURL, constructApfPlusResourcesURL, initialState, messageBeansMock, parseDacResponse, retryUntil, selectMessages, selectState, setAlertsData, setMessages, setMessagesForCard };
